// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
:root {
  --color-bg: #edf7ff;
  --color-surface: #ffffff;
  --color-border: #d9e5f2;
  --color-text: #1d2b3c;
  --color-text-muted: #68788e;
  --color-primary: #2379f4;
  --color-primary-hover: #1267dc;
  --color-primary-light: #e8f2ff;
  --color-success: #16833b;
  --color-success-bg: #e7f6eb;
  --color-error: #e43045;
  --color-error-bg: #fff0f2;
  --color-warning: #f1a62a;
  --radius: 6px;
  --radius-lg: 10px;
  --shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  --font: Inter, 'Segoe UI', Roboto, Arial, sans-serif;
}
html,
body,
#root {
  height: 100%;
}
body {
  font-family: var(--font);
  background: var(--color-bg);
  color: var(--color-text);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
/* ── Buttons ── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.55rem 1.1rem;
  border: 1px solid transparent;
  border-radius: var(--radius);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  font-family: inherit;
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
/* Self-contained so it also looks right without the .btn base class. */
.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 36px;
  padding: 0.55rem 1.1rem;
  border: 1px solid transparent;
  border-radius: var(--radius);
  background: var(--color-primary);
  color: #fff;
  font: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.btn-primary:hover:not(:disabled) {
  background: var(--color-primary-hover);
}
.btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
/* Self-contained so it also looks right without the .btn base class. */
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 36px;
  padding: 0.55rem 1.1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.btn-secondary:hover:not(:disabled) {
  background: var(--color-bg);
}
.btn-secondary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 36px;
  padding: 0.55rem 1.1rem;
  border: 1px solid transparent;
  border-radius: var(--radius);
  background: transparent;
  color: var(--color-text-muted);
  font: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.btn-ghost:hover:not(:disabled) {
  background: var(--color-bg);
  color: var(--color-text);
  border-color: var(--color-border);
}
.btn-ghost:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn-full {
  width: 100%;
}
/* ── Logo ── */
.logo-mark {
  width: 40px;
  height: 40px;
  border-radius: var(--radius);
  background: var(--color-primary);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}
.logo-mark.sm {
  width: 32px;
  height: 32px;
  font-size: 0.75rem;
}
/* ── Login ── */
.login-page {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(160deg, #e8f1f8 0%, var(--color-bg) 50%);
}
.login-card {
  width: 100%;
  max-width: 400px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  padding: 2rem;
}
.login-header {
  text-align: center;
  margin-bottom: 1.75rem;
}
.login-header .logo-mark {
  margin: 0 auto 1rem;
}
.login-header h1 {
  font-size: 1.35rem;
  font-weight: 600;
}
.login-header p {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  margin-top: 0.25rem;
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.login-form label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text-muted);
}
.login-form input {
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 0.95rem;
  font-family: inherit;
  transition: border-color 0.15s;
}
.login-form input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px var(--color-primary-light);
}
.login-divider {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 1.25rem 0;
  color: var(--color-text-muted);
  font-size: 0.8rem;
}
.login-divider::before,
.login-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--color-border);
}
/* ── Alerts ── */
.alert {
  padding: 0.75rem 1rem;
  border-radius: var(--radius);
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.alert-error {
  background: var(--color-error-bg);
  color: var(--color-error);
  border: 1px solid #f5c6c2;
}
.alert-success {
  background: var(--color-success-bg);
  color: var(--color-success);
  border: 1px solid #b8dfc9;
}
/* ── Layout ── */
.app-layout {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border);
}
.header-brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 1rem;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.user-menu {
  position: relative;
}
.user-label {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.85rem;
  color: var(--color-text-muted);
  background: none;
  border: none;
  padding: 0.25rem 0.4rem;
  border-radius: var(--radius);
  cursor: pointer;
  font-family: inherit;
}
.user-label:hover,
.user-label.is-open {
  color: var(--color-text);
  background: var(--color-bg);
}
.user-menu-panel {
  position: absolute;
  top: calc(100% + 0.4rem);
  right: 0;
  z-index: 80;
  min-width: 240px;
  padding: 0.85rem 1rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}
.user-menu-title {
  margin: 0 0 0.65rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.user-menu-details {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.user-menu-details > div {
  display: grid;
  grid-template-columns: 4.5rem 1fr;
  gap: 0.5rem;
  align-items: baseline;
}
.user-menu-details dt {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-text-muted);
}
.user-menu-details dd {
  margin: 0;
  font-size: 0.9rem;
  color: var(--color-text);
  word-break: break-word;
}
.user-menu-muted {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.user-menu-error {
  margin: 0;
  font-size: 0.85rem;
  color: #b91c1c;
}
.app-nav {
  display: flex;
  gap: 0.25rem;
  padding: 0.5rem 1.5rem;
  background: var(--color-surface);
  border-bottom: 1px solid var(--color-border);
}
.nav-link {
  padding: 0.45rem 0.9rem;
  border-radius: var(--radius);
  text-decoration: none;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  font-weight: 500;
  transition: background 0.15s, color 0.15s;
}
.nav-link:hover {
  background: var(--color-bg);
  color: var(--color-text);
}
.nav-link-primary {
  color: var(--color-primary);
  background: var(--color-primary-light);
}
.nav-link-primary:hover {
  background: #d4e6f3;
  color: var(--color-primary-hover);
}
.app-main {
  flex: 1;
  padding: 1.5rem;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
/* ── Page ── */
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}
.page-header h1 {
  font-size: 1.5rem;
  font-weight: 600;
}
.page-subtitle {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  margin-top: 0.15rem;
}
.result-count {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  padding-top: 0.35rem;
}
/* ── Dashboard overview ── */
.dashboard-overview {
  margin-bottom: 1rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.dashboard-overview-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.75rem;
}
.dashboard-overview-toggle {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: baseline;
  gap: 0.65rem 1rem;
  flex: 1 1 14rem;
  min-width: 0;
  padding: 0.85rem 1rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: inherit;
}
.dashboard-overview-toggle:hover {
  background: #f7faff;
}
.dashboard-overview-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem 0.75rem;
  padding: 0.45rem 1rem 0.65rem;
}
.dashboard-overview-title {
  font-size: 0.95rem;
  font-weight: 650;
  color: #243447;
}
.dashboard-overview-subtitle {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
.dashboard-overview-chevron {
  font-size: 0.85rem;
  color: #5e6f84;
  justify-self: end;
}
.dashboard-overview-body {
  padding: 0 1rem 1rem;
  border-top: 1px solid var(--color-border);
}
.overview-scope-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
  margin-top: 0.85rem;
}
.overview-scope-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 14rem;
}
.overview-scope-field-compact {
  flex: 1 1 8.5rem;
  min-width: 0;
  max-width: 100%;
}
.overview-scope-field-compact .overview-scope-select {
  max-width: 100%;
  min-width: 0;
}
.overview-scope-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.overview-scope-select {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0.4rem 0.55rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
  font: inherit;
  font-size: 0.875rem;
  color: var(--color-text);
}
.overview-scope-hint {
  font-size: 0.8rem;
  color: var(--color-text-muted);
  padding-bottom: 0.35rem;
}
.overview-scope-hint-error {
  color: var(--color-error, #e43045);
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}
.overview-status {
  margin: 0.85rem 0 0;
  font-size: 0.875rem;
  color: var(--color-text-muted);
}
.overview-status-error {
  color: var(--color-error, #e43045);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}
.overview-metric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(9.5rem, 1fr));
  gap: 0.75rem;
  margin-top: 0.9rem;
}
.overview-metric {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.7rem 0.8rem;
  border: 1px solid #e7eef6;
  border-radius: var(--radius-md, 8px);
  background: #fbfcfe;
  min-height: 4.25rem;
}
.overview-metric-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #5e6f84;
}
.overview-metric-value {
  font-size: 1.25rem;
  font-weight: 650;
  color: #243447;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}
.overview-metric-hint {
  font-size: 0.72rem;
  color: var(--color-text-muted);
}
.overview-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.75rem;
}
/* ── Filters ── */
.filters-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
  padding: 1rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  margin-bottom: 1rem;
}
.filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--color-text-muted);
  min-width: 0;
  max-width: 100%;
}
.filter-field input,
.filter-field select {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 0.9rem;
  font-family: inherit;
  background: var(--color-surface);
}
.filter-field input[type='date']::-webkit-datetime-edit {
  min-width: 0;
}
.filter-field input:focus,
.filter-field select:focus {
  outline: none;
  border-color: var(--color-primary);
}
.filter-field-grow {
  flex: 1 1 220px;
  min-width: min(100%, 200px);
}
.filter-clear {
  align-self: flex-end;
  margin-bottom: 1px;
}
/* ── Table ── */
.table-wrap {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.referrals-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.referrals-table th {
  text-align: left;
  padding: 0.75rem 1rem;
  background: var(--color-bg);
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-bottom: 1px solid var(--color-border);
}
.referrals-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--color-border);
}
.referrals-table tbody tr:last-child td {
  border-bottom: none;
}
.referrals-table tbody tr:hover {
  background: #fafbfc;
}
.status-with-overdue {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.referrals-table th.col-date,
.referrals-table td.col-date {
  min-width: 8rem;
}
.referrals-table th.col-datetime,
.referrals-table td.col-datetime {
  min-width: 11rem;
  white-space: nowrap;
}
.referrals-table th.col-created-by,
.referrals-table td.col-created-by {
  min-width: 8rem;
}
.referrals-table th.col-owner,
.referrals-table td.col-owner {
  min-width: 8rem;
}
.referrals-table th.col-issue-type,
.referrals-table td.col-issue-type {
  min-width: 12rem;
  max-width: 18rem;
}
.referrals-table td.col-issue-type span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.referrals-table th.col-level,
.referrals-table td.col-level {
  min-width: 4.5rem;
  white-space: nowrap;
}
.referrals-table th.col-case-id,
.referrals-table td.col-case-id {
  min-width: 6rem;
  white-space: nowrap;
}
.referrals-table tbody.referral-group.has-children tr td {
  border-bottom-color: #d9e4f0;
}
.referrals-table tbody.referral-group.has-children tr:first-child td {
  border-top: 2px solid #b7c9de;
}
.referrals-table tbody.referral-group.has-children tr:last-child td {
  border-bottom: 2px solid #b7c9de;
}
.referrals-table tbody.referral-group.has-children tr.is-parent-row td {
  background: #f4f8fd;
}
.referrals-table tbody.referral-group.has-children tr.is-child-row td {
  background: #fbfdff;
}
.referrals-table tbody.referral-group.has-children tr.is-child-row td:first-child {
  padding-left: 1.5rem;
  box-shadow: inset 3px 0 0 #7ea3c7;
}
.referrals-table tbody.referral-group + tbody.referral-group tr:first-child td {
  border-top-width: 2px;
}
.child-parent-hint {
  margin-top: 0.15rem;
  color: #68788e;
  font-size: 0.72rem;
  font-weight: 500;
}
.referral-card-group {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.referral-card-group.has-children {
  padding: 0.45rem;
  border: 2px solid #b7c9de;
  border-radius: var(--radius-lg);
  background: #f7faff;
}
.referral-card-group .referral-card {
  margin: 0;
}
.referral-card.is-child-row {
  margin-left: 0;
  border-left: 3px solid #7ea3c7;
}
.th-label {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
}
.referrals-table th.col-status,
.referrals-table td.col-status {
  min-width: 10rem;
  width: auto;
}
.referral-overdue-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  background: var(--color-error, #e43045);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
}
.mono {
  font-family: 'Cascadia Code', 'Consolas', monospace;
  font-size: 0.82rem;
}
.table-empty {
  padding: 3rem;
  text-align: center;
  color: var(--color-text-muted);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
}
.l15-edit-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.l15-edit-empty p {
  margin: 0;
  max-width: 36rem;
}
.text-muted {
  color: var(--color-text-muted);
}
.referral-id-link {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.referral-id-link:hover {
  text-decoration: underline;
}
/* Mobile card list — shown under 768px; table stays on desktop. */
.referrals-cards {
  display: none;
}
.referrals-cards-sort {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
}
.referrals-cards-sort .th-sort {
  padding: 0.4rem 0.65rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm, 6px);
  background: var(--color-surface);
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}
.referrals-cards-sort .th-sort-active {
  border-color: var(--color-primary);
  background: #edf6ff;
  color: var(--color-primary);
}
.referrals-card-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}
.referral-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 0.9rem 1rem;
}
.referral-card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.75rem;
}
.referral-card-head .referral-id-link {
  font-size: 1rem;
}
.referral-card-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem 1.25rem;
  margin: 0;
}
.referral-card-meta > div {
  flex: 1 1 7.5rem;
  min-width: 0;
}
.referral-card-meta dt {
  margin: 0 0 0.15rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted);
}
.referral-card-meta dd {
  margin: 0;
  font-size: 0.875rem;
  color: var(--color-text);
  overflow-wrap: anywhere;
}
/* ── Referral detail ── */
.back-link {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: var(--color-text-muted);
  text-decoration: none;
  font-size: 0.85rem;
}
.back-link:hover {
  color: var(--color-primary);
}
.referral-detail {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.detail-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 1.25rem 1.5rem;
}
.detail-card h2 {
  margin: 0 0 1rem;
  font-size: 1.05rem;
}
.scheduled-appointments-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.scheduled-appointment {
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: #fafbfd;
}
.scheduled-appointment .detail-meta {
  margin: 0;
}
.detail-card-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.detail-card-heading h2 {
  margin: 0;
}
.detail-attachment-upload {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.detail-attachment-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.detail-attachment-upload-btn {
  font-size: 0.82rem;
  padding: 0.35rem 0.75rem;
}
.detail-attachment-success {
  margin: 0 0 0.75rem;
  color: var(--color-success, #15803d);
  font-size: 0.88rem;
}
.detail-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
  margin: 0;
}
.detail-meta dt {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-text-muted);
  margin-bottom: 0.2rem;
}
.detail-meta dd {
  margin: 0;
  font-size: 0.9rem;
}
.detail-related-links {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.85rem;
}
.detail-meta a,
.alert a {
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.detail-meta a:hover,
.alert a:hover {
  text-decoration: underline;
}
.related-incidents-list {
  display: grid;
  gap: 0.65rem;
}
.related-incident-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.8rem 0.95rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  color: var(--color-text);
  background: #fafcff;
  text-decoration: none;
}
.related-incident-card:hover {
  border-color: var(--color-primary);
  background: #f1f7ff;
}
.related-incident-card > span {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.related-incident-card > span:last-child {
  align-items: flex-end;
  color: var(--color-text-muted);
  font-size: 0.8rem;
  text-align: right;
}
.persons-involved-badges {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.person-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: 100%;
  padding: 0.4rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-bg, #f8fafc);
  color: inherit;
  text-decoration: none;
  font-size: 0.85rem;
  line-height: 1.2;
}
.person-badge.is-patient {
  border-color: var(--color-primary);
  border-width: 2px;
  background: #e8f2ff;
  box-shadow: 0 0 0 1px rgba(43, 108, 176, 0.12);
}
a.person-badge:hover {
  border-color: var(--color-primary);
  background: #edf6ff;
}
a.person-badge.is-patient:hover {
  background: #dcecff;
}
.person-badge-name {
  font-weight: 600;
  color: var(--color-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.person-badge-type {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
}
.person-manage-btn {
  flex-shrink: 0;
}
.site-value {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  flex-wrap: wrap;
}
.site-missing {
  color: var(--color-danger, #b42318);
  font-weight: 600;
}
.site-change-btn {
  min-height: 28px;
  padding: 0.15rem 0.6rem;
  font-size: 0.75rem;
}
/* The editor is wider than one summary column, so give it its own full row. */
.detail-site-cell.is-editing {
  grid-column: 1 / -1;
}
.site-editor {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  max-width: 34rem;
}
.site-editor select {
  flex: 1 1 16rem;
  min-width: 0;
  min-height: 36px;
  padding: 0.4rem 0.55rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
  font-size: 0.875rem;
}
.site-editor .detail-attachment-error {
  flex: 1 1 100%;
  margin: 0;
}
.site-editor-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.person-editor {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.person-editor-row {
  display: grid;
  grid-template-columns: auto repeat(2, minmax(6.5rem, 1fr)) repeat(2, minmax(6.5rem, 0.75fr)) minmax(9.5rem, 1.1fr) auto;
  gap: 0.4rem 0.45rem;
  align-items: end;
  padding: 0.5rem 0.55rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md, 8px);
  background: var(--color-bg, #f8fafc);
}
.person-editor-row .person-user-picker {
  align-self: end;
}
.person-editor-row label {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--color-text-muted);
}
.person-editor-row input,
.person-editor-row select {
  width: 100%;
  min-height: 2rem;
  padding: 0.3rem 0.45rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
  color: var(--color-text);
  font: inherit;
  font-size: 0.88rem;
  font-weight: 400;
}
.person-remove-btn {
  min-height: 2rem;
  padding: 0.3rem 0.55rem;
  border: 1px solid #e5a6a6;
  border-radius: 6px;
  background: #fff5f5;
  color: #a52828;
  font-size: 0.82rem;
  cursor: pointer;
}
.site-user-picker {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
}
.site-user-picker-trigger {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
  color: var(--color-text-muted);
  cursor: pointer;
}
.site-user-picker-trigger svg {
  width: 1.1rem;
  height: 1.1rem;
}
.site-user-picker-trigger:hover:not(:disabled) {
  border-color: var(--color-primary);
  color: var(--color-primary);
  background: var(--color-primary-light);
}
.site-user-picker-trigger.is-selected,
.site-user-picker-trigger.is-open {
  border-color: var(--color-primary);
  color: var(--color-primary);
  background: var(--color-primary-light);
}
.site-user-picker-trigger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.site-user-picker-menu {
  position: fixed;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 0.4rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-surface, #fff);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
.site-user-picker-search {
  flex: none;
  width: 100%;
  min-height: 2rem;
  margin-bottom: 0.3rem;
  padding: 0.3rem 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
  color: var(--color-text);
  font: inherit;
  font-size: 0.85rem;
}
.site-user-picker-options {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1 1 auto;
  overflow: auto;
  min-height: 0;
}
.site-user-picker-option {
  appearance: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.05rem;
  padding: 0.4rem 0.5rem;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--color-text);
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.site-user-picker-option.is-active,
.site-user-picker-option:hover {
  background: rgba(43, 108, 176, 0.08);
}
.site-user-picker-option.is-current {
  box-shadow: inset 2px 0 0 var(--color-primary);
}
.site-user-picker-option.is-clear {
  color: var(--color-text-muted);
  font-size: 0.8rem;
}
.site-user-picker-option-name {
  font-size: 0.88rem;
  font-weight: 600;
}
.site-user-picker-option-email,
.site-user-picker-option-meta {
  color: var(--color-text-muted);
  font-size: 0.75rem;
  font-weight: 400;
  word-break: break-word;
}
.site-user-picker-empty {
  padding: 0.55rem 0.5rem;
  color: var(--color-text-muted);
  font-size: 0.82rem;
}
.person-editor-actions,
.person-editor-actions-right {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.person-editor-actions {
  justify-content: space-between;
}
@media (max-width: 900px) {
  .person-editor-row {
    grid-template-columns: auto repeat(2, minmax(0, 1fr));
  }
  .person-editor-row .person-user-picker {
    grid-row: 1 / span 2;
    align-self: start;
    margin-top: 1.15rem;
  }
  .person-editor-row .person-remove-btn {
    justify-self: start;
  }
}
@media (max-width: 560px) {
  .person-editor-row {
    grid-template-columns: auto 1fr;
  }
  .person-editor-row .person-user-picker {
    grid-row: 1;
    margin-top: 1.15rem;
  }
  .person-editor-row label,
  .person-editor-row .person-remove-btn {
    grid-column: 2;
  }
  .person-editor-actions {
    align-items: stretch;
    flex-direction: column;
  }
  .person-editor-actions-right {
    justify-content: flex-end;
  }
}
.referral-updates-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.referral-updates-new-count {
  display: inline-flex;
  align-items: center;
  margin-left: 0.55rem;
  padding: 0.12rem 0.5rem;
  border-radius: 999px;
  background: #edf6ff;
  border: 1px solid rgba(43, 108, 176, 0.28);
  color: var(--color-primary, #2b6cb0);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  vertical-align: middle;
}
.referral-update {
  --update-accent: var(--color-border);
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-left: 3px solid var(--update-accent);
  border-radius: var(--radius-md, 8px);
  background: var(--color-bg, #f8fafc);
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}
.referral-update--l1-processor {
  --update-accent: #2b6cb0;
}
.referral-update--esd113 {
  --update-accent: #9b2c2c;
}
.referral-update--adjuster {
  --update-accent: #2b6cb0;
}
.referral-update--admin {
  --update-accent: #6b46c1;
}
.referral-update--provider {
  --update-accent: #2f855a;
}
.referral-update--manager {
  --update-accent: #c05621;
}
.referral-update--inspire {
  --update-accent: #319795;
}
.referral-update--school-building {
  --update-accent: #2379f4;
}
.referral-update--system {
  --update-accent: #718096;
}
.referral-update.is-new {
  background: #f3f8ff;
  box-shadow: none;
}
.referral-update-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.35rem 1rem;
  margin-bottom: 0.45rem;
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.referral-update-meta time {
  font-weight: 600;
  color: var(--color-text);
}
.referral-update-meta-left {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}
.referral-update-type {
  display: inline-flex;
  align-items: center;
  padding: 0.06rem 0.4rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.7);
  color: var(--update-accent, var(--color-text-muted));
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.referral-update-meta-right {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}
.referral-update-new-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.08rem 0.4rem;
  border-radius: 999px;
  background: var(--color-primary, #2b6cb0);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.referral-update-by::before {
  content: 'by ';
  font-weight: 400;
  color: var(--color-text-muted);
}
.referral-update-tags {
  list-style: none;
  margin: 0 0 0.45rem;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}
.referral-update-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.08rem 0.45rem;
  border-radius: 999px;
  background: rgba(43, 108, 176, 0.1);
  border: 1px solid rgba(43, 108, 176, 0.22);
  color: #2b6cb0;
  font-size: 0.72rem;
  font-weight: 700;
}
.referral-update-description {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--color-text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.referral-update-mention {
  display: inline;
  padding: 0 0.15rem;
  border-radius: 3px;
  background: rgba(43, 108, 176, 0.12);
  color: #2b6cb0;
  font-weight: 700;
}
.referral-updates-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.85rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--color-border);
}
.referral-post-update-btn {
  appearance: none;
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-text-muted);
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 0.85rem;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}
.referral-post-update-btn:hover {
  color: var(--color-text);
  border-color: rgba(43, 108, 176, 0.35);
  background: rgba(43, 108, 176, 0.04);
}
.referral-post-update-btn:focus-visible {
  outline: none;
  border-color: var(--color-primary, #2b6cb0);
  box-shadow: 0 0 0 3px rgba(43, 108, 176, 0.16);
}
.referral-tasks-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.referral-task {
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-left: 3px solid #2b6cb0;
  border-radius: var(--radius-md, 8px);
  background: var(--color-bg, #f8fafc);
}
.referral-task.is-done {
  border-left-color: #2f855a;
  background: rgba(47, 133, 90, 0.04);
}
.referral-task-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem 1rem;
}
.referral-task-title {
  margin: 0 0 0.3rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--color-text);
}
.referral-task-meta {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.85rem;
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.referral-task-status {
  font-weight: 700;
  color: #2b6cb0;
}
.referral-task-status.is-done {
  color: #2f855a;
}
.referral-task-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  align-items: center;
}
.referral-task-updates {
  list-style: none;
  margin: 0.7rem 0 0;
  padding: 0.65rem 0 0;
  border-top: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.referral-task-update {
  padding: 0.45rem 0 0;
}
.detail-task-select {
  display: block;
  width: 100%;
  min-height: 2.5rem;
  margin: 0 0 0.75rem;
  padding: 0.45rem 0.55rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
  color: var(--color-text);
  font: inherit;
}
/* ── Form tiles ── */
.form-tile-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}
.form-tile {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  cursor: pointer;
  text-align: left;
  font: inherit;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;
}
.form-tile:hover {
  border-color: var(--color-primary);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}
.form-tile:active {
  transform: translateY(1px);
}
.form-tile-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: var(--radius);
  background: var(--color-primary-light);
  color: var(--color-primary);
}
.form-tile-body {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}
.form-tile-title {
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.3;
}
.form-tile-source {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
.form-tile-meta {
  font-size: 0.75rem;
  color: var(--color-text-muted);
}
/* ── Detail attachments ── */
.detail-attachment-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}
@media (min-width: 576px) {
  .detail-attachment-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 768px) {
  .detail-attachment-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.detail-attachment-item {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  gap: 0.75rem;
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md, 8px);
  background: var(--color-bg, #f8fafc);
}
.detail-attachment-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: var(--radius, 6px);
  background: var(--color-primary-light, #e0f2fe);
  color: var(--color-primary);
}
.detail-attachment-body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}
.detail-attachment-name {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--color-text);
  word-break: break-word;
}
button.detail-attachment-link {
  color: var(--color-primary);
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: left;
  cursor: pointer;
  word-break: break-word;
}
button.detail-attachment-link:hover:not(:disabled) {
  text-decoration: underline;
}
button.detail-attachment-link:disabled {
  opacity: 0.7;
  cursor: wait;
}
.detail-attachment-download {
  align-self: flex-start;
  margin-top: 0.2rem;
  padding: 0;
  border: none;
  background: none;
  color: var(--color-primary);
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}
.detail-attachment-download:hover:not(:disabled) {
  color: var(--color-primary-dark, var(--color-primary));
}
.detail-attachment-download:disabled {
  opacity: 0.7;
  cursor: wait;
}
.detail-attachment-error {
  margin: 0 0 0.75rem;
  color: var(--color-error);
  font-size: 0.85rem;
}
.detail-attachment-meta {
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.detail-forms-hint {
  margin: 0 0 0.75rem;
}
/* ── Form modal ── */
.form-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 3vh 1rem;
  background: rgba(15, 23, 42, 0.45);
  overflow-y: auto;
}
.form-modal {
  width: 100%;
  max-width: 920px;
  background: var(--color-bg);
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  max-height: 94vh;
}
.form-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}
.form-modal-header h2 {
  margin: 0;
  font-size: 1.05rem;
}
.form-modal-source {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}
.form-modal-close {
  border: none;
  background: none;
  font-size: 1.1rem;
  line-height: 1;
  padding: 0.35rem 0.5rem;
  border-radius: var(--radius);
  cursor: pointer;
  color: var(--color-text-muted);
}
.form-modal-close:hover {
  background: var(--color-bg);
  color: var(--color-text);
}
.form-modal-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.quill-html-display {
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: #fafbfc;
  font-size: 0.9rem;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.quill-html-display p {
  margin: 0 0 0.5em;
}
.quill-html-display p:last-child {
  margin-bottom: 0;
}
.quill-html-display ul,
.quill-html-display ol {
  margin: 0.35em 0 0.35em 1.25em;
  padding: 0;
}
.quill-html-display a {
  color: var(--color-primary);
}
.quill-html-display .quill-html-empty {
  margin: 0;
  color: var(--color-text-muted);
}
.form-modal-body {
  overflow-y: auto;
  padding: 0.5rem 1rem 1rem;
}
.form-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.65rem;
  padding: 0.85rem 1.25rem;
  border-top: 1px solid var(--color-border);
  background: var(--color-surface);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}
/* ── Pagination ── */
.pagination {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}
.pagination-info {
  grid-column: 1;
  justify-self: start;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.pagination-controls {
  grid-column: 2;
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.pagination-page {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.pagination-controls .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-pages {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.pagination-page-btn {
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid var(--color-border);
  background: var(--color-surface, #fff);
  border-radius: var(--radius);
  font-size: 0.85rem;
  color: var(--color-text, #0f172a);
  cursor: pointer;
}
.pagination-page-btn:hover:not(:disabled):not(.active) {
  background: var(--color-bg);
}
.pagination-page-btn.active {
  background: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
  font-weight: 600;
}
.pagination-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-gap {
  padding: 0 0.25rem;
  color: var(--color-text-muted);
}
.pagination-jump {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.pagination-jump input {
  width: 4rem;
  height: 2rem;
  padding: 0 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 0.85rem;
}
/* Sortable column headers */
.referrals-table th {
  padding: 0;
}
.th-sort {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.th-sort:hover {
  color: var(--color-text, #0f172a);
}
.th-sort-active {
  color: var(--color-primary);
}
.th-sort-arrow {
  font-size: 0.7rem;
  opacity: 0.5;
}
.th-sort-active .th-sort-arrow {
  opacity: 1;
}
/* ── Badges ── */
.status-badge,
.type-badge {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}
.status-0 {
  background: var(--color-primary-light);
  color: var(--color-primary);
}
.status-1 {
  background: #fef9e7;
  color: var(--color-warning);
}
.status-2 {
  background: var(--color-success-bg);
  color: var(--color-success);
}
.status-3 {
  background: #f0f0f5;
  color: #555;
}
/* ── Tabs ── */
.tab-bar {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
  border-bottom: 1px solid var(--color-border);
}
.tab {
  padding: 0.6rem 1.1rem;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s;
}
.tab:hover {
  color: var(--color-text);
}
.tab.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}
/* ── Form switcher (referral + added supporting forms) ── */
.form-switcher {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin: -0.5rem 0 1.25rem;
}
.form-switcher-item {
  display: inline-flex;
  align-items: stretch;
  max-width: 100%;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-surface, #fff);
  overflow: hidden;
}
.form-switcher-item.active {
  border-color: var(--color-primary);
  background: #eef2ff;
}
.form-switcher-tab {
  padding: 0.45rem 0.9rem;
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-surface, #fff);
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.form-switcher-item .form-switcher-tab {
  border: 0;
  border-radius: 0;
  background: transparent;
}
.form-switcher-item.active .form-switcher-tab {
  color: var(--color-primary);
}
.form-switcher-tab:hover {
  color: var(--color-text);
  border-color: var(--color-text-muted);
}
.form-switcher-tab.active {
  color: var(--color-primary);
  border-color: var(--color-primary);
  background: #eef2ff;
}
.form-switcher-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  padding: 0 0.45rem 0 0.15rem;
  border: 0;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}
.form-switcher-remove:hover {
  color: var(--color-error, #e43045);
}
.form-switcher-tab--add {
  border-style: dashed;
}
.form-switcher-tab--add.is-open,
.form-switcher-tab--add:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}
.add-form-menu {
  position: relative;
}
.add-form-menu-list {
  position: absolute;
  top: calc(100% + 0.4rem);
  left: 0;
  z-index: 60;
  min-width: 16rem;
  max-width: min(22rem, 80vw);
  margin: 0;
  padding: 0.35rem;
  list-style: none;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg, 10px);
  background: var(--color-surface, #fff);
  box-shadow: var(--shadow);
}
.add-form-menu-option {
  display: block;
  width: 100%;
  padding: 0.55rem 0.7rem;
  border: 0;
  border-radius: var(--radius, 6px);
  background: transparent;
  color: var(--color-text);
  font: inherit;
  font-size: 0.85rem;
  text-align: left;
  cursor: pointer;
}
.add-form-menu-option:hover {
  background: #eef2ff;
  color: var(--color-primary);
}
/* New Referral: compact sticky chrome + form switcher */
.page--new-referral .new-referral-chrome {
  position: sticky;
  top: 0;
  z-index: 50;
  margin: -0.35rem 0 0.85rem;
  padding: 0.35rem 0 0.65rem;
  background: var(--color-bg);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 8px 12px -10px rgba(7, 51, 127, 0.18);
}
.page--new-referral .page-header--compact {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem 0.75rem;
  margin-bottom: 0.35rem;
}
.page--new-referral .page-header--compact h1 {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
}
.page--new-referral .page-header--compact .page-subtitle {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.3;
  color: var(--color-text-muted);
}
.page--new-referral .tab-bar {
  margin-bottom: 0.5rem;
}
.page--new-referral .tab {
  padding: 0.4rem 0.85rem;
  font-size: 0.82rem;
}
.page--new-referral .form-switcher {
  margin: 0;
  gap: 0.35rem;
}
.page--new-referral .form-switcher-tab {
  padding: 0.3rem 0.7rem;
  font-size: 0.78rem;
}
.page--new-referral .form-switcher-remove {
  min-width: 1.35rem;
  font-size: 0.95rem;
}
.page--new-referral .add-form-menu-option {
  font-size: 0.8rem;
}
.form-load-error {
  padding: 2rem;
  text-align: center;
  color: var(--color-error);
}
.form-load-error p {
  margin-bottom: 1rem;
}
/* ── SurveyJS overrides ── */
.survey-container {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  position: relative;
}
.survey-container .sd-root-modern {
  --sjs-primary-backcolor: var(--color-primary);
  --sjs-primary-backcolor-dark: var(--color-primary-hover);
  --sjs-general-backcolor: var(--color-surface);
  --sjs-border-default: var(--color-border);
}
.overlay-msg {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  z-index: 10;
  border-radius: var(--radius-lg);
}
/* Pin to the viewport so long forms still show the spinner on-screen. */
.overlay-msg--viewport {
  position: fixed;
  inset: 0;
  z-index: 2000;
  border-radius: 0;
  background: rgba(15, 23, 42, 0.35);
}
.overlay-msg-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  padding: 1.25rem 1.5rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.18);
  color: var(--color-text);
  font-size: 0.95rem;
}
.overlay-msg-content .spinner {
  width: 36px;
  height: 36px;
}
/* ── Upload ── */
.upload-panel {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: 2rem;
}
.upload-test-note {
  margin: 1rem 0 0;
  font-size: 0.875rem;
  color: var(--color-text-muted, #64748b);
}
.upload-test-note code {
  font-size: 0.8125rem;
}
.upload-dropzone input[type='file'] {
  display: none;
}
.upload-dropzone label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 3rem 2rem;
  border: 2px dashed var(--color-border);
  border-radius: var(--radius-lg);
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;
}
.upload-dropzone label:hover {
  border-color: var(--color-primary);
  background: var(--color-primary-light);
}
.upload-dropzone strong {
  font-size: 1rem;
}
.upload-dropzone span {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}
.upload-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
}
/* ── Loading ── */
.loading-screen {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: var(--color-text-muted);
}
.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-border);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* ── Responsive ── */
@media (max-width: 768px) {
  .app-main {
    padding: 1rem;
    min-width: 0;
    overflow-x: hidden;
  }
  .page {
    min-width: 0;
    max-width: 100%;
  }
  .filters-panel,
  .dashboard-overview,
  .overview-scope-row,
  .dashboard-overview-controls {
    min-width: 0;
    max-width: 100%;
  }
  .filters-bar {
    flex-direction: column;
    align-items: stretch;
    min-width: 0;
    max-width: 100%;
  }
  .filter-field,
  .filter-field-grow,
  .filter-level-chips,
  .overview-scope-field,
  .overview-scope-field-compact {
    flex: 1 1 100%;
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
  .referrals-table-desktop {
    display: none;
  }
  .referrals-cards {
    display: block;
  }
  .page-header {
    flex-direction: column;
    gap: 0.5rem;
  }
}
/* ── Figma-aligned visual system ── */
body {
  background: #edf7ff;
  font-size: 14px;
}
a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(35, 121, 244, 0.28);
  outline-offset: 2px;
}
.btn {
  min-height: 36px;
  padding: 0.55rem 1.15rem;
  border-radius: 6px;
  font-weight: 600;
  letter-spacing: 0.005em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.btn:active:not(:disabled) {
  transform: translateY(1px);
}
.btn-primary {
  background: #2379f4;
  box-shadow: 0 4px 10px rgba(35, 121, 244, 0.2);
}
.btn-secondary {
  color: #07337f;
  border-color: #c8d6e5;
  box-shadow: 0 1px 2px rgba(5, 40, 98, 0.06);
}
.btn-secondary:hover:not(:disabled) {
  border-color: rgba(35, 121, 244, 0.55);
  background: #edf7ff;
  color: #2379f4;
  box-shadow: 0 2px 8px rgba(35, 121, 244, 0.14);
}
.btn-secondary:active:not(:disabled) {
  background: #e3f2ff;
  box-shadow: none;
  transform: translateY(1px);
}
.btn-secondary:disabled {
  box-shadow: none;
}
.btn-ghost {
  color: #07337f;
  background: transparent;
  border: 1px solid transparent;
  box-shadow: none;
}
.btn-ghost:hover:not(:disabled) {
  color: #2379f4;
  background: #edf7ff;
  border-color: #c8d6e5;
}
.btn-ghost:active:not(:disabled) {
  background: #e3f2ff;
  transform: translateY(1px);
}
.btn-ghost:disabled {
  box-shadow: none;
}
/* Login */
.login-page {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(420px, 576px);
  min-height: 100vh;
  padding: 0;
  background: #ffffff;
}
.login-visual {
  position: relative;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: clamp(2rem, 4vw, 4rem);
  color: #fff;
  background: #0b1932;
}
.login-visual::before {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 46px 46px;
  content: '';
  -webkit-mask-image: linear-gradient(to bottom, #000, transparent 85%);
  mask-image: linear-gradient(to bottom, #000, transparent 85%);
}
.login-visual p {
  position: relative;
  z-index: 1;
  margin: 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.85rem;
  letter-spacing: 0.04em;
}
.login-visual-brand {
  position: relative;
  z-index: 1;
  display: block;
  width: 200px;
  object-fit: contain;
}
.login-illustration {
  position: absolute;
  z-index: 0;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: drop-shadow(0 28px 45px rgba(0, 0, 0, 0.24));
}
.login-panel {
  position: relative;
  display: grid;
  width: 100%;
  max-width: 576px;
  min-height: 100vh;
  justify-self: end;
  place-items: center;
  padding: 3rem clamp(2rem, 5vw, 4.5rem) 5rem;
}
.login-card {
  width: 100%;
  max-width: 430px;
  padding: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.login-header {
  margin-bottom: 2rem;
  text-align: center;
}
.login-header h1 {
  margin-top: 1.5rem;
  color: #1d2b3c;
  font-size: clamp(1.45rem, 2vw, 1.85rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}
.login-header p {
  margin-top: 0.5rem;
  color: #68788e;
}
.login-logo {
  display: inline-block;
  max-height: 100px;
  object-fit: contain;
}
.login-form {
  gap: 1.15rem;
}
.login-form label {
  gap: 0.45rem;
  color: #1d2b3c;
  font-size: 0.8rem;
  font-weight: 600;
}
.login-form input {
  min-height: 44px;
  padding: 0.7rem 0.85rem;
  border-color: #cdd8e4;
  border-radius: 6px;
  color: #1d2b3c;
}
.login-form input:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
.login-form .btn {
  min-height: 42px;
  margin-top: 0.25rem;
}
.login-divider {
  margin: 1.4rem 0;
}
.footer-need-help {
  position: absolute;
  right: clamp(2rem, 5vw, 4.5rem);
  bottom: 1.5rem;
  left: clamp(2rem, 5vw, 4.5rem);
  color: #68788e;
  font-size: 0.82rem;
  text-align: left;
}
.footer-need-help a {
  color: #2671ff;
  font-weight: 500;
  text-decoration: none;
}
.footer-need-help a:hover {
  text-decoration: underline;
}
/* Shared shell */
.app-header {
  position: relative;
  z-index: 70;
  min-height: 72px;
  padding: 0;
  border: 0;
  background: #edf7ff;
  border-bottom: 1px solid #d9e5f2;
}
.app-header-inner,
.app-nav-inner {
  display: flex;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  padding-inline: clamp(1rem, 3vw, 2.5rem);
}
.app-header-inner {
  position: relative;
  min-height: 72px;
}
.header-brand {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  color: #2379f4;
  font-size: 0.92rem;
  text-decoration: none;
  z-index: 1;
}
.header-logo {
  width: auto;
  height: 34px;
  object-fit: contain;
}
.header-client-logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 52px;
  object-fit: cover;
  pointer-events: none;
}
.header-brand-divider {
  width: 1px;
  height: 24px;
  margin-inline: 0.15rem;
  background: rgba(35, 121, 244, 0.35);
}
.header-product {
  font-weight: 600;
}
.header-actions {
  gap: 0.85rem;
  z-index: 1;
}
.user-label {
  color: #2379f4;
  border-radius: 999px;
}
.user-label:hover,
.user-label.is-open {
  color: #07337f;
  background: rgba(35, 121, 244, 0.1);
}
.btn-header {
  min-height: 32px;
  padding: 0.35rem 0.9rem;
  border: 1px solid #2379f4;
  color: #2379f4;
  background: transparent;
}
.btn-header:hover {
  border-color: #07337f;
  color: #07337f;
  background: rgba(35, 121, 244, 0.1);
}
.user-menu-panel {
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  top: calc(100% + 0.65rem);
}
.app-nav {
  min-height: 52px;
  padding: 0;
  background: #ffffff;
  border-bottom-color: #d9e5f2;
}
.app-nav-inner {
  min-height: 52px;
}
.nav-tabs {
  display: flex;
  align-self: stretch;
  align-items: center;
  gap: 0.25rem;
}
.nav-link {
  position: relative;
  display: inline-flex;
  min-height: 52px;
  align-items: center;
  padding: 0.55rem 0.7rem;
  border-radius: 0;
  color: #68788e;
  font-size: 0.8rem;
}
.nav-link::after {
  position: absolute;
  right: 0.7rem;
  bottom: -1px;
  left: 0.7rem;
  height: 2px;
  border-radius: 2px 2px 0 0;
  background: transparent;
  content: '';
}
.nav-link:hover {
  color: #2379f4;
  background: transparent;
}
.nav-link.active {
  color: #2379f4;
}
.nav-link.active::after {
  background: #2379f4;
}
.nav-link-count {
  margin-left: 0.15rem;
  color: #68788e;
  font-weight: 400;
}
.nav-link-primary {
  min-height: 34px;
  padding: 0.45rem 1rem;
  gap: 0.45rem;
  border-radius: 999px;
  color: #fff;
  background: #2379f4;
  box-shadow: 0 3px 9px rgba(35, 121, 244, 0.2);
}
.nav-link-primary::after {
  display: none;
}
.nav-link-primary:hover {
  color: #fff;
  background: #1267dc;
}
.nav-new-icon {
  display: inline-flex;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1rem;
  line-height: 1;
}
.app-main {
  max-width: 1500px;
  padding: clamp(1.25rem, 3vw, 2.5rem);
}
.app-footer {
  width: 100%;
  margin-top: auto;
  padding: 0;
  border-top: 1px solid #dce7f6;
  color: #53647b;
  background: #f3f7ff;
}
.app-footer-inner {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.app-footer-inner p {
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.55;
}
.app-footer-inner a {
  color: #0b2f73;
  font-weight: 700;
  text-decoration: none;
}
.app-footer-inner a:hover {
  text-decoration: underline;
}
.app-footer-powered {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  width: 100%;
  margin: 0%;
  padding: 0.75rem clamp(1rem, 3vw, 2.5rem);
  background: #07337f;
  color: rgba(255, 255, 255, 0.78);
}
.app-footer-powered-label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}
.app-footer-powered-logo {
  width: auto;
  height: 36px;
  object-fit: contain;
}
.app-footer-privacy {
  max-width: 1180px;
  margin: 0.3rem auto 0 !important;
  font-size: 10px !important;
  line-height: 1.45 !important;
}
/* Content and data surfaces */
.page-header {
  margin-bottom: 1.5rem;
  align-items: center;
}
.page-header h1 {
  color: #1d2b3c;
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 700;
  letter-spacing: -0.025em;
}
.page-subtitle {
  margin-top: 0.3rem;
  color: #68788e;
}
.result-count {
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  color: #07337f;
  background: #e4f0ff;
  font-weight: 600;
}
.filters-panel {
  margin-bottom: 1rem;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 5px 18px rgba(7, 51, 127, 0.05);
}
.filters-toggle {
  display: flex;
  width: 100%;
  border-radius: 10px 10px 0 0;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.15rem;
  border: 0;
  color: #1d2b3c;
  background: #ffffff;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
}
.filters-toggle:hover {
  background: #f8fbff;
}
.filters-toggle-meta {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
}
.filters-toggle-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.filters-icon {
  width: 17px;
  height: 17px;
  color: #2379f4;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.filters-active-count {
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  color: #2379f4;
  background: #e9f3ff;
  font-size: 0.7rem;
  font-weight: 600;
}
.filters-chevron {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #2379f4;
  background: #e9f3ff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.15s ease;
}
.filters-panel:not(.is-expanded) .filters-toggle {
  border-radius: 10px;
}
.filters-panel.is-expanded .filters-chevron {
  transform: rotate(180deg);
}
.filters-bar {
  margin: 0;
  padding: 1rem 1.15rem 1.15rem;
  border: 0;
  border-top: 1px solid #e7eef6;
  border-radius: 0 0 10px 10px;
  background: #fbfdff;
}
.filters-bar .filter-field {
  color: #68788e;
  font-size: 0.74rem;
  font-weight: 600;
}
.filters-bar .filter-field input,
.filters-bar .filter-field select {
  min-height: 38px;
  border-color: #cad7e4;
  border-radius: 6px;
  color: #1d2b3c;
}
.filters-bar .filter-field input:focus,
.filters-bar .filter-field select:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
.filter-actions {
  display: flex;
  flex: 1 0 100%;
  align-self: flex-end;
  justify-content: flex-end;
  gap: 0.55rem;
  margin-top: 0.15rem;
  margin-left: 0;
}
.filter-actions .btn {
  min-width: 84px;
}
.filter-field-multiselect {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.filter-field-label {
  display: block;
}
.filter-level-chips {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
  max-width: 100%;
}
.level-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.level-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 38px;
  padding: 0 0.75rem;
  border: 1px solid #cad7e4;
  border-radius: 999px;
  background: #fff;
  color: #1d2b3c;
  font-size: 0.8rem;
  font-weight: 650;
  cursor: pointer;
}
.level-chip input {
  margin: 0;
}
.level-chip.is-selected {
  border-color: #07337f;
  background: #e4f0ff;
  color: #07337f;
}
.filter-multiselect-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 38px;
  padding: 0.4rem 0.7rem;
  border: 1px solid #cad7e4;
  border-radius: 6px;
  background: #ffffff;
  color: #1d2b3c;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}
.filter-multiselect-trigger:hover,
.filter-multiselect-trigger.is-open {
  border-color: #2379f4;
}
.filter-multiselect-trigger:focus-visible {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
.filter-multiselect-summary {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-multiselect-chevron {
  flex-shrink: 0;
  color: #68788e;
}
.filter-multiselect-panel {
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  z-index: 30;
  max-height: 16rem;
  overflow: auto;
  padding: 0.45rem;
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.filter-multiselect-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}
.filter-multiselect-action {
  min-height: 0;
  padding: 0.2rem 0.45rem;
  font-size: 0.78rem;
}
.filter-multiselect-options {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}
.filter-multiselect-option {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.4rem 0.45rem;
  border-radius: 6px;
  color: #1d2b3c;
  font-size: 0.84rem;
  font-weight: 500;
  cursor: pointer;
}
.filter-multiselect-option:hover {
  background: rgba(35, 121, 244, 0.08);
}
.filter-multiselect-option.is-child {
  padding-left: 1.35rem;
  font-weight: 400;
}
.filter-multiselect-option input {
  margin-top: 0.15rem;
  flex-shrink: 0;
}
.table-wrap {
  border-color: #d9e5f2;
  border-top: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.referrals-table {
  font-size: 0.82rem;
}
.referrals-table th {
  background: #f7faff;
  border-color: #d9e5f2;
}
.referrals-table td {
  padding: 0.7rem 1rem;
  border-color: #e7eef6;
  color: #344357;
}
.referrals-table tbody tr {
  transition: background 0.12s ease;
}
.referrals-table tbody tr:hover {
  background: #f3f8ff;
}
.th-sort {
  color: #5e6f84;
  font-size: 0.72rem;
  letter-spacing: 0.025em;
}
.referral-id-link {
  color: #2f64b8;
}
.status-badge,
.type-badge {
  min-width: 58px;
  padding: 0.22rem 0.55rem;
  border-radius: 4px;
  color: #fff;
  font-size: 0.68rem;
  letter-spacing: 0.01em;
  text-align: center;
}
.detail-header-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
}
.detail-update-inspire-btn {
  font-size: 0.82rem;
  padding: 0.35rem 0.75rem;
}
.update-inspire-overlay {
  overflow: visible;
}
.update-inspire-modal {
  max-width: 520px;
  max-height: none;
  margin-top: 12vh;
  overflow: visible;
}
.copy-from-parent-modal {
  max-width: 560px;
}
.copy-from-parent-subtitle {
  margin: 0.25rem 0 0;
  color: var(--color-text-muted);
  font-size: 0.85rem;
  font-weight: 400;
}
.copy-from-parent-section {
  margin-bottom: 1rem;
}
.copy-from-parent-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.4rem;
}
.copy-from-parent-section-head h3 {
  margin: 0;
  font-size: 0.92rem;
}
.copy-from-parent-select-all {
  padding: 0.2rem 0.45rem;
  font-size: 0.8rem;
}
.copy-from-parent-list {
  list-style: none;
  margin: 0;
  padding: 0.25rem;
  max-height: 12rem;
  overflow: auto;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: #fff;
}
.copy-from-parent-option {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  padding: 0.4rem 0.45rem;
  border-radius: 5px;
  cursor: pointer;
}
.copy-from-parent-option:hover {
  background: rgba(43, 108, 176, 0.08);
}
.copy-from-parent-option input {
  margin-top: 0.2rem;
}
.copy-from-parent-option-title,
.copy-from-parent-option-meta {
  display: block;
}
.copy-from-parent-option-title {
  font-size: 0.88rem;
  font-weight: 600;
}
.copy-from-parent-option-meta {
  color: var(--color-text-muted);
  font-size: 0.75rem;
  font-weight: 400;
}
.update-inspire-modal-body,
.update-inspire-modal .form-modal-body {
  overflow: visible;
  padding: 1.1rem 1.25rem 1.25rem;
}
.detail-update-inspire-label {
  display: block;
  margin-bottom: 0.4rem;
  font-weight: 600;
  font-size: 0.9rem;
}
.update-mention-field {
  position: relative;
  margin: 0 0 0.75rem;
}
.update-mention-field .detail-update-inspire-textarea {
  margin-bottom: 0;
}
.update-mention-menu {
  list-style: none;
  margin: 0;
  padding: 0.25rem;
  position: fixed;
  z-index: 10000;
  max-height: 14rem;
  overflow: auto;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: var(--color-surface, #fff);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}
.update-mention-option {
  appearance: none;
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.45rem 0.55rem;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text);
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.update-mention-option.is-active,
.update-mention-option:hover {
  background: rgba(43, 108, 176, 0.08);
}
.update-mention-option-name {
  font-weight: 600;
}
.update-mention-option-handle {
  color: var(--color-text-muted);
  font-size: 0.8rem;
}
.detail-update-inspire-textarea {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 0.75rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  font: inherit;
  font-size: 0.9rem;
  line-height: 1.45;
  resize: vertical;
  min-height: 5.5rem;
  background: var(--color-surface, #fff);
  color: var(--color-text);
}
.detail-update-inspire-textarea:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 1px;
}
.detail-update-inspire-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
.status-0 {
  color: #fff;
  background: #21833f;
}
.status-1 {
  color: #fff;
  background: #eea62b;
}
.status-2 {
  color: #fff;
  background: #858b95;
}
.status-3 {
  color: #fff;
  background: #eb3349;
}
.pagination {
  margin-top: 1.25rem;
  padding-inline: 0.25rem;
}
.pagination-controls {
  gap: 0.45rem;
}
.pagination-page-btn {
  border-radius: 5px;
}
.pagination-page-btn.active {
  background: #2379f4;
  border-color: #2379f4;
}
.pagination-jump input:focus {
  outline: none;
  border-color: #2379f4;
  box-shadow: 0 0 0 3px rgba(35, 121, 244, 0.16);
}
/* Details, tabs, forms, and overlays */
.back-link {
  color: #2379f4;
  font-weight: 600;
}
.referral-detail {
  gap: 1rem;
}
.detail-card {
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  padding: 1.35rem 1.5rem;
}
.detail-card h2 {
  padding-bottom: 0.8rem;
  border-bottom: 1px solid #e7eef6;
  color: #1d2b3c;
  font-size: 1rem;
}
.detail-meta {
  gap: 1.25rem 1.5rem;
}
.detail-meta dt {
  color: #68788e;
  font-size: 0.7rem;
  font-weight: 600;
}
.detail-meta dd {
  color: #1d2b3c;
  font-weight: 500;
}
.form-tile {
  border-color: #d9e5f2;
  box-shadow: 0 3px 12px rgba(5, 40, 98, 0.05);
}
.form-tile:hover {
  border-color: #2379f4;
  box-shadow: 0 7px 18px rgba(35, 121, 244, 0.12);
}
.form-tile-icon {
  color: #2379f4;
  background: #e6f1ff;
}
.tab-bar {
  border-color: #d9e5f2;
}
.tab {
  color: #68788e;
  font-size: 0.82rem;
  font-weight: 600;
}
.tab.active {
  color: #2379f4;
  border-bottom-color: #2379f4;
}
.survey-container,
.upload-panel {
  background: #ffffff;
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.survey-container .sd-root-modern,
.survey-panel-side .sd-root-modern,
.form-modal .sd-root-modern {
  --sjs-primary-backcolor: #2379f4;
  --sjs-primary-backcolor-dark: #1267dc;
  --sjs-primary-backcolor-light: #e9f3ff;
  --sjs-general-backcolor: #ffffff;
  --sjs-general-forecolor: #1d2b3c;
  --sjs-border-default: #d9e5f2;
  --sjs-font-family: var(--font);
}
.upload-dropzone label {
  border-color: #b9cee3;
  background: #f8fbff;
}
.upload-dropzone label:hover {
  border-color: #2379f4;
  background: #edf6ff;
}
.alert {
  border-radius: 6px;
  box-shadow: 0 4px 14px rgba(5, 40, 98, 0.05);
}
.table-empty,
.form-load-error {
  border-color: #d9e5f2;
  background: #ffffff;
  box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
}
.form-modal-overlay {
  background: rgba(5, 40, 98, 0.55);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.form-modal {
  border: 1px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 28px 70px rgba(5, 40, 98, 0.35);
}
.loading-screen {
  color: #68788e;
  background: #edf7ff;
}
@media (max-width: 900px) {
  .login-visual {
    padding: 2rem;
  }
  .header-product,
  .header-brand-divider {
    display: none;
  }
  .pagination {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  .pagination-info,
  .pagination-controls {
    grid-column: 1;
  }
  .pagination-controls {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
}
@media (max-width: 680px) {
  .login-page {
    display: block;
  }
  .login-visual {
    min-height: 150px;
    padding: 1.5rem;
  }
  .login-panel {
    min-height: calc(100vh - 150px);
    padding: 2.25rem 1.25rem 4.5rem;
  }
  .footer-need-help {
    right: 1.25rem;
    left: 1.25rem;
  }
  .app-header-inner {
    min-height: 64px;
  }
  .header-logo {
    height: 28px;
  }
  .header-client-logo {
    width: 44px;
    height: 44px;
  }
  .header-product {
    max-width: 7.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .user-label-name {
    display: inline-block;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .app-nav-inner {
    padding-inline: 0.75rem;
  }
  .nav-link {
    padding-inline: 0.55rem;
  }
  .app-main {
    padding: 1rem 0.75rem 2rem;
  }
  .filters-panel {
    margin-bottom: 0.75rem;
  }
  .filters-bar {
    margin: 0;
    border-radius: 0;
  }
  .filter-actions {
    width: 100%;
    justify-content: flex-end;
    margin-left: 0;
  }
  .table-wrap {
    border-top: 1px solid #d9e5f2;
    border-radius: 10px;
  }
  .referral-card {
    border-color: #d9e5f2;
    box-shadow: 0 8px 28px rgba(5, 40, 98, 0.08);
  }
  .referrals-cards-sort .th-sort {
    border-color: #d9e5f2;
  }
  .detail-card {
    padding: 1rem;
  }
  .detail-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .form-modal-overlay {
    padding: 0;
  }
  .form-modal {
    min-height: 100vh;
    max-height: none;
    border-radius: 0;
  }
}
@media (max-width: 430px) {
  .header-actions {
    gap: 0.35rem;
  }
  .header-brand-divider,
  .header-product {
    display: none;
  }
  .header-brand {
    display: none;
  }
  .header-client-logo {
    position: static;
    left: auto;
    top: auto;
    width: auto;
    height: 40px;
    margin-right: auto;
    transform: none;
    object-fit: contain;
  }
  .user-label {
    padding-inline: 0.25rem;
  }
  .user-label-name {
    max-width: 78px;
  }
  .btn-header {
    padding-inline: 0.7rem;
  }
  .nav-tabs .nav-link.active[aria-current='page'] {
    display: none;
  }
  .detail-meta {
    grid-template-columns: 1fr;
  }
  .referral-card-head .status-with-overdue {
    width: 100%;
  }
}
@media (max-height: 720px) and (min-width: 681px) {
  .login-panel {
    padding-block: 1.25rem;
  }
  .login-header {
    margin-bottom: 1.25rem;
  }
  .login-header h1 {
    margin-top: 0.8rem;
  }
  .login-logo {
    width: 30px;
    height: 43px;
  }
  .login-form {
    gap: 0.75rem;
  }
  .login-divider {
    margin-block: 0.9rem;
  }
  .footer-need-help {
    bottom: 0.85rem;
  }
}
.mobile-test-page {
  min-height: 100%;
  background: #ffffff;
}
.mobile-test-page .sd-root-modern {
  --sjs-primary-backcolor: #2379f4;
  --sjs-primary-backcolor-dark: #1267dc;
  --sjs-general-backcolor: #ffffff;
  --sjs-general-forecolor: #1d2b3c;
  --sjs-border-default: #d9e5f2;
  --sjs-font-family: var(--font);
}
.mobile-test-page .sd-body.sd-body--responsive {
  padding: 0.5rem 0.35rem 1.5rem;
}
/* FAF runtime step UI (google address + inline alert). */
.faf-google-address {
  width: 100%;
}
.faf-google-address-row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}
.faf-google-address-input {
  flex: 1 1 auto;
  width: 100%;
  min-height: 2.75rem;
  padding: 0.65rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm, 6px);
  background: var(--color-surface, #fff);
  color: var(--color-text);
  font: inherit;
}
.faf-google-address-input:focus {
  border-color: var(--color-primary);
  outline: 2px solid rgba(43, 108, 176, 0.18);
  outline-offset: 1px;
}
.faf-google-address-map-btn {
  flex: 0 0 auto;
  min-width: 4.25rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm, 6px);
  background: #f8fafc;
  color: var(--color-text);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.faf-google-address-map-btn:hover {
  border-color: var(--color-primary);
  background: #edf6ff;
}
.faf-google-address.has-error .faf-google-address-input {
  border-color: #dc2626;
}
.faf-inline-alert {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0.35rem 0 0.65rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid #f5c2c7;
  border-radius: var(--radius-sm, 6px);
  background: #fde8e8;
  color: #842029;
  font-size: 0.85rem;
  line-height: 1.35;
}
.faf-inline-alert-text {
  flex: 1 1 auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.faf-inline-alert-close {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;
  padding: 0 0.15rem;
  opacity: 0.75;
}
.faf-inline-alert-close:hover {
  opacity: 1;
}
.faf-google-map-overlay {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.45);
}
.faf-google-map-dialog {
  width: min(720px, 100%);
  max-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: var(--radius-md, 8px);
  background: var(--color-surface, #fff);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.28);
}
.faf-google-map-dialog-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--color-border);
}
.faf-google-map-hint {
  font-size: 0.78rem;
  color: var(--color-text-muted);
}
.faf-google-map-canvas {
  width: 100%;
  height: min(420px, 55vh);
  background: #e2e8f0;
}
.faf-google-map-preview {
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  font-size: 0.9rem;
  color: var(--color-text);
  min-height: 2.75rem;
}
.faf-google-map-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.less","webpack://./src/styles/faf.less"],"names":[],"mappings":"AA6BA;;;EAGE,sBAAA;EACA,SAAA;EACA,UAAA;AA5BF;AA+BA;EACE,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,aAAA;EACA,iBAAA;EACA,0CAAA;EACA,oDAAA;AA7BF;AAgCA;;;EAGE,YAAA;AA9BF;AAiCA;EACE,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,gBAAA;EACA,mCAAA;AA/BF;AACA,kBAAkB;AAmClB;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,oBAAA;AAjCF;AAoCA;EACE,aAAA;EACA,mBAAA;AAlCF;AACA,uEAAuE;AAqCvE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,8EAAA;AAnCF;AAyCA;EACE,sCAAA;AAvCF;AA0CA;EACE,aAAA;EACA,mBAAA;AAxCF;AACA,uEAAuE;AA2CvE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yHAAA;AAzCF;AAiDA;EACE,2BAAA;AA/CF;AAkDA;EACE,aAAA;EACA,mBAAA;AAhDF;AAmDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,yHAAA;AAjDF;AAyDA;EACE,2BAAA;EACA,wBAAA;EACA,iCAAA;AAvDF;AA0DA;EACE,aAAA;EACA,mBAAA;AAxDF;AA2DA;EACE,WAAA;AAzDF;AACA,eAAe;AA6Df;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AA3DF;AA8DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA5DF;AACA,gBAAgB;AAgEhB;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,oEAAA;AA9DF;AAiEA;EACE,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;AA/DF;AAkEA;EACE,kBAAA;EACA,sBAAA;AAhEF;AAmEA;EACE,mBAAA;AAjEF;AAoEA;EACE,kBAAA;EACA,gBAAA;AAlEF;AAqEA;EACE,8BAAA;EACA,iBAAA;EACA,mBAAA;AAnEF;AAsEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApEF;AAuEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AArEF;AAwEA;EACE,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BAAA;AAtEF;AAyEA;EACE,aAAA;EACA,kCAAA;EACA,gDAAA;AAvEF;AA0EA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,8BAAA;EACA,iBAAA;AAxEF;AA2EA;;EAEE,WAAA;EACA,OAAA;EACA,WAAA;EACA,+BAAA;AAzEF;AACA,iBAAiB;AA6EjB;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;AA3EF;AA8EA;EACE,iCAAA;EACA,yBAAA;EACA,yBAAA;AA5EF;AA+EA;EACE,mCAAA;EACA,2BAAA;EACA,yBAAA;AA7EF;AACA,iBAAiB;AAiFjB;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AA/EF;AAkFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,4CAAA;AAhFF;AAmFA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAjFF;AAoFA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAlFF;AAqFA;EACE,kBAAA;AAnFF;AAsFA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,oBAAA;AApFF;AAuFA;;EAEE,wBAAA;EACA,2BAAA;AArFF;AAwFA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,6CAAA;AAtFF;AAyFA;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAvFF;AA0FA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAxFF;AA2FA;EACE,aAAA;EACA,iCAAA;EACA,WAAA;EACA,qBAAA;AAzFF;AA4FA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AA1FF;AA6FA;EACE,SAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;AA3FF;AA8FA;EACE,SAAA;EACA,kBAAA;EACA,8BAAA;AA5FF;AA+FA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;AA7FF;AAgGA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gCAAA;EACA,4CAAA;AA9FF;AAiGA;EACE,uBAAA;EACA,4BAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AA/FF;AAkGA;EACE,2BAAA;EACA,wBAAA;AAhGF;AAmGA;EACE,2BAAA;EACA,sCAAA;AAjGF;AAoGA;EACE,mBAAA;EACA,iCAAA;AAlGF;AAqGA;EACE,OAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAnGF;AACA,eAAe;AAuGf;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;AArGF;AAwGA;EACE,iBAAA;EACA,gBAAA;AAtGF;AAyGA;EACE,8BAAA;EACA,iBAAA;EACA,mBAAA;AAvGF;AA0GA;EACE,kBAAA;EACA,8BAAA;EACA,oBAAA;AAxGF;AACA,6BAA6B;AA4G7B;EACE,mBAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AA1GF;AA6GA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AA3GF;AA8GA;EACE,aAAA;EACA,oCAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA5GF;AA+GA;EACE,mBAAA;AA7GF;AAgHA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;AA9GF;AAiHA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AA/GF;AAkHA;EACE,iBAAA;EACA,8BAAA;AAhHF;AAmHA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AAjHF;AAoHA;EACE,oBAAA;EACA,yCAAA;AAlHF;AAqHA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAnHF;AAsHA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AApHF;AAuHA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;AArHF;AAwHA;EACE,eAAA;EACA,YAAA;AAtHF;AAyHA;EACE,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAvHF;AA0HA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AAxHF;AA2HA;EACE,iBAAA;EACA,8BAAA;EACA,uBAAA;AAzHF;AA4HA;EACE,kCAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AA1HF;AA6HA;EACE,mBAAA;EACA,mBAAA;EACA,8BAAA;AA3HF;AA8HA;EACE,kCAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AA5HF;AA+HA;EACE,aAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;AA7HF;AAgIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AA9HF;AAiIA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA/HF;AAkIA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;AAhIF;AAmIA;EACE,kBAAA;EACA,8BAAA;AAjIF;AAoIA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAlIF;AACA,kBAAkB;AAsIlB;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,mBAAA;AApIF;AAuIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AArIF;AAwIA;;EAEE,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCAAA;AAtIF;AAyIA;EACE,YAAA;AAvIF;AA0IA;;EAEE,aAAA;EACA,kCAAA;AAxIF;AA2IA;EACE,eAAA;EACA,2BAAA;AAzIF;AA4IA;EACE,oBAAA;EACA,kBAAA;AA1IF;AACA,gBAAgB;AA8IhB;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;AA5IF;AA+IA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AA7IF;AAgJA;EACE,gBAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;EACA,4CAAA;AA9IF;AAiJA;EACE,qBAAA;EACA,4CAAA;AA/IF;AAkJA;EACE,mBAAA;AAhJF;AAmJA;EACE,mBAAA;AAjJF;AAoJA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAlJF;AAqJA;;EAEE,eAAA;AAnJF;AAsJA;;EAEE,gBAAA;EACA,mBAAA;AApJF;AAuJA;;EAEE,eAAA;AArJF;AAwJA;;EAEE,eAAA;AAtJF;AAyJA;;EAEE,gBAAA;EACA,gBAAA;AAvJF;AA0JA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAxJF;AA2JA;;EAEE,iBAAA;EACA,mBAAA;AAzJF;AA4JA;;EAEE,eAAA;EACA,mBAAA;AA1JF;AA6JA;EAEI,4BAAA;AA5JJ;AA0JA;EAMI,6BAAA;AA7JJ;AAuJA;EAUI,gCAAA;AA9JJ;AAoJA;EAcI,mBAAA;AA/JJ;AAiJA;EAkBI,mBAAA;AAhKJ;AA8IA;EAsBI,oBAAA;EACA,iCAAA;AAjKJ;AAqKA;EACE,qBAAA;AAnKF;AAsKA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AApKF;AAuKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AArKF;AAwKA;EACE,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,mBAAA;AAtKF;AAyKA;EACE,SAAA;AAvKF;AA0KA;EACE,cAAA;EACA,8BAAA;AAxKF;AA2KA;EACE,oBAAA;EACA,gBAAA;EACA,mBAAA;AAzKF;AA4KA;;EAEE,gBAAA;EACA,WAAA;AA1KF;AA6KA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,uCAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA3KF;AA8KA;EACE,mDAAA;EACA,kBAAA;AA5KF;AA+KA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;EACA,qCAAA;EACA,+BAAA;AA7KF;AAgLA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA9KF;AA0KA;EAOI,SAAA;EACA,gBAAA;AA9KJ;AAkLA;EACE,8BAAA;AAhLF;AAmLA;EACE,2BAAA;EACA,gBAAA;EACA,qBAAA;AAjLF;AAoLA;EACE,0BAAA;AAlLF;AACA,kEAAkE;AAqLlE;EACE,aAAA;AAnLF;AAsLA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AApLF;AAuLA;EACE,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AArLF;AAwLA;EACE,kCAAA;EACA,mBAAA;EACA,2BAAA;AAtLF;AAyLA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAvLF;AA0LA;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,oBAAA;AAxLF;AA2LA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAzLF;AA4LA;EACE,eAAA;AA1LF;AA6LA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,SAAA;AA3LF;AAuLA;EAOI,gBAAA;EACA,YAAA;AA3LJ;AAmLA;EAYI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;AA5LJ;AA2KA;EAqBI,SAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;AA7LJ;AACA,0BAA0B;AAkM1B;EACE,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AAhMF;AAmMA;EACE,2BAAA;AAjMF;AAoMA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlMF;AAqMA;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,uBAAA;AAnMF;AAsMA;EACE,gBAAA;EACA,kBAAA;AApMF;AAuMA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AArMF;AAwMA;EACE,qBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;AAtMF;AAyMA;EACE,SAAA;AAvMF;AA0MA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AAxMF;AAkMA;EASI,SAAA;AAxMJ;AA4MA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA1MF;AA6MA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA3MF;AA8MA;EACE,kBAAA;EACA,wBAAA;AA5MF;AA+MA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;AA7MF;AAgNA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,SAAA;AA9MF;AAiNA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;AA/MF;AAkNA;EACE,SAAA;EACA,iBAAA;AAhNF;AAmNA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;AAjNF;AAoNA;;EAEE,2BAAA;EACA,gBAAA;EACA,qBAAA;AAlNF;AAqNA;;EAEE,0BAAA;AAnNF;AAsNA;EACE,aAAA;EACA,YAAA;AApNF;AAuNA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,wBAAA;EACA,mBAAA;EACA,qBAAA;AArNF;AAuNE;EACE,kCAAA;EACA,mBAAA;AArNJ;AAuMA;EAkBI,aAAA;EACA,sBAAA;EACA,WAAA;AAtNJ;AAkMA;EAwBI,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,iBAAA;AAvNJ;AA2NA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AAzNF;AA4NA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,qCAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AA1NF;AA6NA;EACE,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;AA3NF;AA8NA;EACE,kCAAA;EACA,mBAAA;AA5NF;AA+NA;EACE,mBAAA;AA7NF;AAgOA;EACE,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA9NF;AAiOA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kCAAA;AA/NF;AAkOA;EACE,cAAA;AAhOF;AAmOA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAjOF;AAoOA;EACE,mCAAA;EACA,gBAAA;AAlOF;AAqOA;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;AAnOF;AACA,8EAA8E;AAsO9E;EACE,mBAAA;AApOF;AAuOA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AArOF;AAgOA;EAQI,eAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AArOJ;AAoNA;EAqBI,cAAA;EACA,SAAA;AAtOJ;AA0OA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAxOF;AA2OA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAzOF;AA4OA;EACE,aAAA;EACA,uHAAA;EAMA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,oCAAA;AA/OF;AAkOA;EAgBI,eAAA;AA/OJ;AA+NA;EAoBI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;AAhPJ;AAsNA;;EA+BI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAjPJ;AAqPA;EACE,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAnPF;AAsPA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;AApPF;AAuPA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;AArPF;AAyOA;EAeI,aAAA;EACA,cAAA;AArPJ;AAwPE;EACE,kCAAA;EACA,2BAAA;EACA,sCAAA;AAtPJ;AAyPE;;EAEE,kCAAA;EACA,2BAAA;EACA,sCAAA;AAvPJ;AA0PE;EACE,aAAA;EACA,mBAAA;AAxPJ;AA4PA;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,sCAAA;EACA,2CAAA;EACA,gBAAA;AA1PF;AA6PA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;AA3PF;AA8PA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;AA5PF;AA+PA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AA7PF;AAgQA;;EAEE,oCAAA;AA9PF;AAiQA;EACE,8CAAA;AA/PF;AAkQA;EACE,8BAAA;EACA,iBAAA;AAhQF;AAmQA;EACE,kBAAA;EACA,gBAAA;AAjQF;AAoQA;;EAEE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAlQF;AAqQA;EACE,uBAAA;EACA,8BAAA;EACA,kBAAA;AAnQF;AAsQA;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AApQF;AAuQA;EACE,8BAAA;AArQF;AAwQA;EACE;IACE,qDAAA;EAtQF;EAqQA;IAII,oBAAA;IACA,iBAAA;IACA,mBAAA;EAtQJ;EAgQA;IAUI,mBAAA;EAvQJ;AACF;AA2QA;EACE;IACE,+BAAA;EAzQF;EAwQA;IAII,WAAA;IACA,mBAAA;EAzQJ;EAoQA;;IAUI,cAAA;EA1QJ;EA8QA;IACE,oBAAA;IACA,sBAAA;EA5QF;EA+QA;IACE,yBAAA;EA7QF;AACF;AAgRA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA9QF;AAiRA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AA/QF;AAkRA;EACE,oCAAA;EACA,qBAAA;EACA,qCAAA;EACA,2CAAA;EACA,oCAAA;EACA,oCAAA;EACA,iFAAA;AAhRF;AAmRA;EACE,wBAAA;AAjRF;AAoRA;EACE,wBAAA;AAlRF;AAqRA;EACE,wBAAA;AAnRF;AAsRA;EACE,wBAAA;AApRF;AAuRA;EACE,wBAAA;AArRF;AAwRA;EACE,wBAAA;AAtRF;AAyRA;EACE,wBAAA;AAvRF;AA0RA;EACE,wBAAA;AAxRF;AA2RA;EACE,wBAAA;AAzRF;AA4RA;EACE,mBAAA;EACA,gBAAA;AA1RF;AA6RA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;AA3RF;AAmRA;EAWI,gBAAA;EACA,wBAAA;AA3RJ;AA+RA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AA7RF;AAgSA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,oCAAA;EACA,oDAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA9RF;AAiSA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AA/RF;AAkSA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAhSF;AAoSE;EACE,cAAA;EACA,gBAAA;EACA,8BAAA;AAlSJ;AAsSA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AApSF;AAuSA;EACE,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,oBAAA;EACA,mCAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AArSF;AAwSA;EACE,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;AAtSF;AAySA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,gBAAA;AAvSF;AA0SA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yCAAA;AAxSF;AA2SA;EACE,gBAAA;EACA,qCAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,4EAAA;AAzSF;AA4SA;EACE,wBAAA;EACA,sCAAA;EACA,oCAAA;AA1SF;AA6SA;EACE,aAAA;EACA,2CAAA;EACA,8CAAA;AA3SF;AA8SA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA5SF;AA+SA;EACE,qBAAA;EACA,qCAAA;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;AA7SF;AAgTA;EACE,0BAAA;EACA,mCAAA;AA9SF;AAiTA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;AA/SF;AAkTA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AAhTF;AAmTA;EACE,SAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;AAjTF;AAoTA;EACE,gBAAA;EACA,cAAA;AAlTF;AAoTE;EACE,cAAA;AAlTJ;AAsTA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AApTF;AAuTA;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yCAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AArTF;AAwTA;EACE,oBAAA;AAtTF;AAyTA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,aAAA;AAvTF;AACA,qBAAqB;AA2TrB;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAzTF;AA4TA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,+BAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iEAAA;AA1TF;AA6TA;EACE,kCAAA;EACA,0CAAA;AA3TF;AA8TA;EACE,0BAAA;AA5TF;AA+TA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;EACA,sCAAA;EACA,2BAAA;AA7TF;AAgUA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AA9TF;AAiUA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AA/TF;AAkUA;EACE,iBAAA;EACA,8BAAA;AAhUF;AAmUA;EACE,kBAAA;EACA,8BAAA;AAjUF;AACA,6BAA6B;AAqU7B;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,0BAAA;EACA,YAAA;AAnUF;AAsUA;EACE;IACE,gDAAA;EApUF;AACF;AAuUA;EACE;IACE,gDAAA;EArUF;AACF;AAwUA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,qCAAA;EACA,oCAAA;EACA,oCAAA;AAtUF;AAyUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,+CAAA;EACA,2BAAA;AAvUF;AA0UA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAxUF;AA2UA;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;AAzUF;AA4UA;EACE,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AA1UF;AA6UA;EACE,0BAAA;AA3UF;AA8UA;EACE,YAAA;EACA,YAAA;AA5UF;AA+UA;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AA7UF;AAgVA;EACE,sDAAA;AA9UF;AAiVA;EACE,YAAA;EACA,YAAA;AA/UF;AAkVA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAhVF;AAmVA;EACE,kBAAA;EACA,8BAAA;AAjVF;AAoVA;EACE,mBAAA;AAlVF;AACA,qBAAqB;AAsVrB;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;AApVF;AAuVA;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,+BAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AArVF;AAwVA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,4CAAA;EACA,gCAAA;EACA,oDAAA;AAtVF;AAyVA;EACE,SAAA;EACA,kBAAA;AAvVF;AA0VA;EACE,iBAAA;EACA,8BAAA;AAxVF;AA2VA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,8BAAA;AAzVF;AA4VA;EACE,2BAAA;EACA,wBAAA;AA1VF;AA6VA;EACE,YAAA;EACA,mBAAA;AA3VF;AA8VA;EACE,wBAAA;EACA,qCAAA;EACA,4BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AA5VF;AAqVA;EAUI,iBAAA;AA5VJ;AAkVA;EAcI,gBAAA;AA7VJ;AA+UA;;EAmBI,8BAAA;EACA,UAAA;AA9VJ;AA0UA;EAwBI,2BAAA;AA/VJ;AAuUA;EA4BI,SAAA;EACA,8BAAA;AAhWJ;AAoWA;EACE,gBAAA;EACA,yBAAA;AAlWF;AAqWA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,wBAAA;EACA,yCAAA;EACA,gCAAA;EACA,oDAAA;AAnWF;AACA,qBAAqB;AAuWrB;EACE,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AArWF;AAwWA;EACE,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AAtWF;AAyWA;EACE,cAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAvWF;AA0WA;EACE,kBAAA;EACA,8BAAA;AAxWF;AA2WA;EACE,YAAA;EACA,mBAAA;AAzWF;AA4WA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA1WF;AA6WA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;AA3WF;AA8WA;EACE,2BAAA;AA5WF;AA+WA;EACE,gCAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AA7WF;AAgXA;EACE,YAAA;EACA,mBAAA;AA9WF;AAiXA;EACE,kBAAA;EACA,8BAAA;AA/WF;AAkXA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AAhXF;AAmXA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,4BAAA;EACA,kBAAA;AAjXF;AACA,4BAA4B;AAoX5B;EACE,UAAA;AAlXF;AAqXA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;AAnXF;AAsXA;EACE,iCAAA;AApXF;AAuXA;EACE,2BAAA;AArXF;AAwXA;EACE,iBAAA;EACA,YAAA;AAtXF;AAyXA;EACE,UAAA;AAvXF;AACA,iBAAiB;AA2XjB;;EAEE,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAzXF;AA4XA;EACE,sCAAA;EACA,2BAAA;AA1XF;AA6XA;EACE,mBAAA;EACA,2BAAA;AA3XF;AA8XA;EACE,mCAAA;EACA,2BAAA;AA5XF;AA+XA;EACE,mBAAA;EACA,WAAA;AA7XF;AACA,eAAe;AAiYf;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,4CAAA;AA/XF;AAkYA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;AAhYF;AAmYA;EACE,wBAAA;AAjYF;AAoYA;EACE,2BAAA;EACA,yCAAA;AAlYF;AACA,4DAA4D;AAsY5D;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;AApYF;AAuYA;EACE,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,qCAAA;EACA,oBAAA;EACA,sCAAA;EACA,gBAAA;AArYF;AAwYA;EACE,kCAAA;EACA,mBAAA;AAtYF;AAyYA;EACE,uBAAA;EACA,qCAAA;EACA,oBAAA;EACA,sCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;EACA,6DAAA;AAvYF;AA0YA;EACE,SAAA;EACA,gBAAA;EACA,uBAAA;AAxYF;AA2YA;EACE,2BAAA;AAzYF;AA4YA;EACE,wBAAA;EACA,qCAAA;AA1YF;AA6YA;EACE,2BAAA;EACA,kCAAA;EACA,mBAAA;AA3YF;AA8YA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AA5YF;AA+YA;EACE,kCAAA;AA7YF;AAgZA;EACE,oBAAA;AA9YF;AAiZA;;EAEE,2BAAA;EACA,kCAAA;AA/YF;AAkZA;EACE,kBAAA;AAhZF;AAmZA;EACE,kBAAA;EACA,wBAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,qCAAA;EACA,sCAAA;EACA,yBAAA;AAjZF;AAoZA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,iCAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAlZF;AAqZA;EACE,mBAAA;EACA,2BAAA;AAnZF;AACA,wDAAwD;AAsZxD;EAEI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4CAAA;EACA,mDAAA;AArZJ;AA4YA;EAaI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;AAtZJ;AAqYA;EAoBM,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAtZN;AA+XA;EA2BM,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAvZN;AAyXA;EAmCI,qBAAA;AAzZJ;AAsXA;EAuCI,uBAAA;EACA,kBAAA;AA1ZJ;AAkXA;EA4CI,SAAA;EACA,YAAA;AA3ZJ;AA8WA;EAiDI,sBAAA;EACA,kBAAA;AA5ZJ;AA0WA;EAsDI,kBAAA;EACA,kBAAA;AA7ZJ;AAsWA;EA2DI,iBAAA;AA9ZJ;AAkaA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AAhaF;AAmaA;EACE,mBAAA;AAjaF;AACA,6BAA6B;AAqa7B;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;AAnaF;AAsaA;EACE,6CAAA;EACA,wDAAA;EACA,6CAAA;EACA,yCAAA;AApaF;AAuaA;EACE,kBAAA;EACA,QAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,+BAAA;AAraF;AACA,wEAAwE;AAwaxE;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,kCAAA;AAtaF;AAyaA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,qCAAA;EACA,6CAAA;EACA,wBAAA;EACA,kBAAA;AAvaF;AA0aA;EACE,WAAA;EACA,YAAA;AAxaF;AACA,iBAAiB;AA4ajB;EACE,gCAAA;EACA,qCAAA;EACA,+BAAA;EACA,aAAA;AA1aF;AA6aA;EACE,gBAAA;EACA,mBAAA;EACA,uCAAA;AA3aF;AA8aA;EACE,oBAAA;AA5aF;AA+aA;EACE,aAAA;AA7aF;AAgbA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gDAAA;AA9aF;AAibA;EACE,kCAAA;EACA,sCAAA;AA/aF;AAkbA;EACE,eAAA;AAhbF;AAmbA;EACE,kBAAA;EACA,8BAAA;AAjbF;AAobA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAlbF;AACA,kBAAkB;AAsblB;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,8BAAA;AApbF;AAubA;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,sCAAA;EACA,kBAAA;EACA,oCAAA;AArbF;AAwbA;EACE;IACE,yBAAA;EAtbF;AACF;AACA,qBAAqB;AA0brB;EACE;IACE,aAAA;IACA,YAAA;IACA,kBAAA;EAxbF;EA2bA;IACE,YAAA;IACA,eAAA;EAzbF;EA4bA;;;;IAIE,YAAA;IACA,eAAA;EA1bF;EA6bA;IACE,sBAAA;IACA,oBAAA;IACA,YAAA;IACA,eAAA;EA3bF;EA8bA;;;;;IAKE,cAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EA5bF;EA+bA;IACE,aAAA;EA7bF;EAgcA;IACE,cAAA;EA9bF;EAicA;IACE,sBAAA;IACA,WAAA;EA/bF;AACF;AACA,sCAAsC;AAmctC;EACE,mBAAA;EACA,eAAA;AAjcF;AAycE;;;;;EACE,2CAAA;EACA,mBAAA;AAncJ;AAucA;EACE,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kGAAA;AArcF;AA2cE;EACE,0BAAA;AAzcJ;AA6cA;EACE,mBAAA;EACA,8CAAA;AA3cF;AA8cA;EACE,cAAA;EACA,qBAAA;EACA,2CAAA;AA5cF;AA8cE;EACE,sCAAA;EACA,mBAAA;EACA,cAAA;EACA,8CAAA;AA5cJ;AA+cE;EACE,mBAAA;EACA,gBAAA;EACA,0BAAA;AA7cJ;AAgdE;EACE,gBAAA;AA9cJ;AAkdA;EACE,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;AAhdF;AAkdE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AAhdJ;AAmdE;EACE,mBAAA;EACA,0BAAA;AAjdJ;AAodE;EACE,gBAAA;AAldJ;AACA,UAAU;AAudV;EACE,aAAA;EACA,0DAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AArdF;AAwdA;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,mBAAA;AAtdF;AAwdE;EACE,kBAAA;EACA,QAAA;EACA,yJAAA;EAGA,0BAAA;EACA,WAAA;EACA,qEAAA;EACA,6DAAA;AAxdJ;AAocA;EAwBI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;AAzdJ;AA6dA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AA3dF;AA8dA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,oDAAA;AA5dF;AA+dA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;AA7dF;AAgeA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AA9dF;AAieA;EACE,mBAAA;EACA,kBAAA;AA/dF;AA6dA;EAKI,kBAAA;EACA,cAAA;EACA,uCAAA;EACA,gBAAA;EACA,wBAAA;AA/dJ;AAsdA;EAaI,kBAAA;EACA,cAAA;AAheJ;AAoeA;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;AAleF;AAqeA;EACE,YAAA;AAneF;AAkeA;EAII,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAneJ;AA4dA;EAWI,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AApeJ;AAseI;EA15FF,aAAA;EACA,qBAAA;EACA,8CAAA;AAu7EF;AAgdA;EAuBI,gBAAA;EACA,mBAAA;AApeJ;AAweA;EACE,gBAAA;AAteF;AAyeA;EACE,kBAAA;EACA,+BAAA;EACA,cAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAveF;AAgeA;EAUI,cAAA;EACA,gBAAA;EACA,qBAAA;AAveJ;AAyeI;EACE,0BAAA;AAveN;AACA,iBAAiB;AA6ejB;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;AA3eF;AA8eA;;EAEE,aAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;AA5eF;AA+eA;EACE,kBAAA;EACA,gBAAA;AA7eF;AAgfA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AA9eF;AAifA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA/eF;AAkfA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AAhfF;AAmfA;EACE,UAAA;EACA,YAAA;EACA,sBAAA;EACA,oCAAA;AAjfF;AAofA;EACE,gBAAA;AAlfF;AAqfA;EACE,YAAA;EACA,UAAA;AAnfF;AAsfA;EACE,cAAA;EACA,oBAAA;AApfF;AAsfE;;EAEE,cAAA;EACA,mCAAA;AApfJ;AAwfA;EACE,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;AAtfF;AAwfE;EACE,qBAAA;EACA,cAAA;EACA,mCAAA;AAtfJ;AA0fA;EAniGE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EAkiGA,yBAAA;AArfF;AAwfA;EACE,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,4BAAA;AAtfF;AAyfA;EACE,gBAAA;AAvfF;AA0fA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAxfF;AA2fA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAzfF;AA2fE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;EACA,uBAAA;EACA,WAAA;AAzfJ;AA4fE;EACE,cAAA;EACA,uBAAA;AA1fJ;AA6fE;EACE,cAAA;AA3fJ;AA6fI;EACE,mBAAA;AA3fN;AAggBA;EACE,oBAAA;EACA,cAAA;EACA,gBAAA;AA9fF;AAigBA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,6CAAA;AA/fF;AAigBE;EACE,aAAA;AA/fJ;AAkgBE;EACE,WAAA;EACA,mBAAA;AAhgBJ;AAogBA;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAlgBF;AAqgBA;EACE,iBAAA;EACA,oCAAA;AAngBF;AAsgBA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,cAAA;EACA,mBAAA;AApgBF;AAugBA;EACE,WAAA;EAEA,cAAA;EACA,kBAAA;AAtgBF;AAkgBA;EAOI,SAAA;EACA,kBAAA;EACA,iBAAA;AAtgBJ;AA6fA;EAaI,cAAA;EACA,gBAAA;EACA,qBAAA;AAvgBJ;AAygBI;EACE,0BAAA;AAvgBN;AA4gBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,yCAAA;EACA,mBAAA;EACA,gCAAA;AA1gBF;AA6gBA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AA3gBF;AA8gBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA5gBF;AA+gBA;EACE,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,4BAAA;AA7gBF;AACA,8BAA8B;AAihB9B;EACE,qBAAA;EACA,mBAAA;AA/gBF;AA6gBA;EAKI,cAAA;EACA,sCAAA;EACA,gBAAA;EACA,wBAAA;AA/gBJ;AAmhBA;EACE,kBAAA;EACA,cAAA;AAjhBF;AAohBA;EACE,wBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAlhBF;AAqhBA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;AAnhBF;AAshBA;EACE,aAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAphBF;AAshBE;EACE,mBAAA;AAphBJ;AAwhBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AAthBF;AAyhBA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAvhBF;AA0hBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAxhBF;AA2hBA;EACE,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAzhBF;AA4hBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AA1hBF;AA6hBA;EACE,mBAAA;AA3hBF;AA8hBA;EACE,yBAAA;AA5hBF;AA+hBA;EACE,SAAA;EACA,6BAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,mBAAA;AA7hBF;AAuhBA;EASI,cAAA;EACA,kBAAA;EACA,gBAAA;AA7hBJ;AAkhBA;;EAeM,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AA7hBN;AA+hBM;;EA9zGJ,aAAA;EACA,qBAAA;EACA,8CAAA;AAmyFF;AAgiBA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AA9hBF;AAuhBA;EAUI,eAAA;AA9hBJ;AAkiBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAhiBF;AAmiBA;EACE,cAAA;AAjiBF;AAoiBA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAliBF;AAqiBA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAniBF;AAsiBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AApiBF;AAwhBA;EAeI,SAAA;AApiBJ;AAuiBE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAriBJ;AAyiBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAviBF;AAyiBE;;EAEE,qBAAA;AAviBJ;AA0iBE;EA95GA,aAAA;EACA,qBAAA;EACA,8CAAA;AAu3FF;AA0iBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAxiBF;AA2iBA;EACE,cAAA;EACA,cAAA;AAziBF;AA4iBA;EACE,kBAAA;EACA,yBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;AA1iBF;AA6iBA;EACE,aAAA;EACA,yBAAA;EACA,sBAAA;AA3iBF;AA8iBA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AA5iBF;AA+iBA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA7iBF;AAgjBA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA9iBF;AAgjBE;EACE,oCAAA;AA9iBJ;AAijBE;EACE,qBAAA;EACA,gBAAA;AA/iBJ;AA8hBA;EAqBI,mBAAA;EACA,cAAA;AAhjBJ;AAojBA;EACE,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,4CAAA;AAljBF;AAqjBA;EACE,kBAAA;AAnjBF;AAkjBA;EAII,mBAAA;EACA,qBAAA;AAnjBJ;AA8iBA;EASI,oBAAA;EACA,qBAAA;EACA,cAAA;AApjBJ;AAyiBA;EAeI,iCAAA;AArjBJ;AAujBI;EACE,mBAAA;AArjBN;AA0jBA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;AAxjBF;AA2jBA;EACE,cAAA;AAzjBF;AA4jBA;;EAEE,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AA1jBF;AA6jBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AA3jBF;AA8jBA;EACE,kBAAA;EACA,wBAAA;AA5jBF;AA+jBA;EACE,iBAAA;AA7jBF;AAgkBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA9jBF;AAikBA;EACE,gBAAA;AA/jBF;AAkkBA;EACE,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAhkBF;AAmkBA;EACE,mBAAA;AAjkBF;AAokBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,qBAAA;AAlkBF;AA6jBA;EAQI,SAAA;EACA,kBAAA;AAlkBJ;AAskBA;EACE,uBAAA;EACA,iBAAA;AApkBF;AAukBA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AArkBF;AAwkBA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAtkBF;AAwkBE;EACE,oCAAA;AAtkBJ;AA6jBA;EAaI,kBAAA;AAvkBJ;AA2kBA;;EAEE,cAAA;AAzkBF;AA4kBA;EACE,kBAAA;EACA,gBAAA;AA1kBF;AA6kBA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;AA3kBF;AA8kBA;;EAEE,iBAAA;EACA,+BAAA;AA5kBF;AA+kBA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;AA7kBF;AAglBA;EACE,kBAAA;EACA,mBAAA;AA9kBF;AAilBA;EACE,gBAAA;AA/kBF;AAklBA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,sCAAA;EACA,yCAAA;AAhlBF;AAmlBA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,wBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAjlBF;AAolBA;;EAEE,oCAAA;AAllBF;AAqlBA;EACE,gBAAA;AAnlBF;AAslBA;EACE,8BAAA;EACA,iBAAA;AAplBF;AAulBA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;EACA,wBAAA;AArlBF;AAwlBA;EACE,uCAAA;EACA,mBAAA;AAtlBF;AAylBA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AAvlBF;AA0lBA;EACE,WAAA;EACA,mBAAA;AAxlBF;AA2lBA;EACE,WAAA;EACA,mBAAA;AAzlBF;AA4lBA;EACE,WAAA;EACA,mBAAA;AA1lBF;AA6lBA;EACE,WAAA;EACA,mBAAA;AA3lBF;AA8lBA;EACE,mBAAA;EACA,uBAAA;AA5lBF;AA+lBA;EACE,YAAA;AA7lBF;AAgmBA;EACE,kBAAA;AA9lBF;AAgmBE;EACE,mBAAA;EACA,qBAAA;AA9lBJ;AAmmBE;EAzwHA,aAAA;EACA,qBAAA;EACA,8CAAA;AAyqGF;AACA,uCAAuC;AAomBvC;EACE,cAAA;EACA,gBAAA;AAlmBF;AAqmBA;EACE,SAAA;AAnmBF;AAsmBA;EAhyHE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;EA+xHA,uBAAA;AAjmBF;AA+lBA;EAKI,sBAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;AAjmBJ;AAqmBA;EACE,mBAAA;AAnmBF;AAkmBA;EAII,cAAA;EACA,iBAAA;EACA,gBAAA;AAnmBJ;AA6lBA;EAUI,cAAA;EACA,gBAAA;AApmBJ;AAwmBA;EACE,qBAAA;EACA,4CAAA;AAtmBF;AAwmBE;EACE,qBAAA;EACA,+CAAA;AAtmBJ;AA0mBA;EACE,cAAA;EACA,mBAAA;AAxmBF;AA2mBA;EACE,qBAAA;AAzmBF;AA4mBA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA1mBF;AA4mBE;EACE,cAAA;EACA,4BAAA;AA1mBJ;AA8mBA;;EAz1HE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4CAAA;AA+uGF;AA4mBA;;;EAGE,gCAAA;EACA,qCAAA;EACA,sCAAA;EACA,gCAAA;EACA,gCAAA;EACA,6BAAA;EACA,8BAAA;AA1mBF;AA6mBA;EACE,qBAAA;EACA,mBAAA;AA3mBF;AA6mBE;EACE,qBAAA;EACA,mBAAA;AA3mBJ;AA+mBA;EACE,kBAAA;EACA,4CAAA;AA7mBF;AAgnBA;;EAEE,qBAAA;EACA,mBAAA;EACA,4CAAA;AA9mBF;AAinBA;EACE,iCAAA;EACA,kCAAA;EACA,0BAAA;AA/mBF;AAknBA;EACE,2CAAA;EACA,6CAAA;AAhnBF;AAmnBA;EACE,cAAA;EACA,mBAAA;AAjnBF;AAonBA;EACE;IACE,aAAA;EAlnBF;EAqnBA;;IAEE,aAAA;EAnnBF;EAsnBA;IACE,0BAAA;IACA,qBAAA;EApnBF;EAunBA;;IAEE,cAAA;EArnBF;EAwnBA;IACE,WAAA;IACA,uBAAA;IACA,eAAA;EAtnBF;AACF;AAynBA;EACE;IACE,cAAA;EAvnBF;EA0nBA;IACE,iBAAA;IACA,eAAA;EAxnBF;EA2nBA;IACE,+BAAA;IACA,+BAAA;EAznBF;EA4nBA;IACE,cAAA;IACA,aAAA;EA1nBF;EA6nBA;IACE,gBAAA;EA3nBF;EA8nBA;IACE,YAAA;EA5nBF;EA+nBA;IACE,WAAA;IACA,YAAA;EA7nBF;EAgoBA;IACE,iBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EA9nBF;EAioBA;IACE,qBAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;EA/nBF;EAkoBA;IACE,uBAAA;EAhoBF;EAmoBA;IACE,uBAAA;EAjoBF;EAooBA;IACE,0BAAA;EAloBF;EAqoBA;IACE,sBAAA;EAnoBF;EAsoBA;IACE,SAAA;IACA,gBAAA;EApoBF;EAuoBA;IACE,WAAA;IACA,yBAAA;IACA,cAAA;EAroBF;EAwoBA;IACE,6BAAA;IACA,mBAAA;EAtoBF;EAyoBA;IACE,qBAAA;IACA,4CAAA;EAvoBF;EA0oBA;IACE,qBAAA;EAxoBF;EA2oBA;IACE,aAAA;EAzoBF;EA4oBA;IACE,gDAAA;EA1oBF;EA6oBA;IACE,UAAA;EA3oBF;EA8oBA;IACE,iBAAA;IACA,gBAAA;IACA,gBAAA;EA5oBF;AACF;AA+oBA;EACE;IACE,YAAA;EA7oBF;EAgpBA;;IAEE,aAAA;EA9oBF;EAipBA;IACE,aAAA;EA/oBF;EAkpBA;IACE,gBAAA;IACA,UAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,mBAAA;EAhpBF;EAmpBA;IACE,uBAAA;EAjpBF;EAopBA;IACE,eAAA;EAlpBF;EAqpBA;IACE,sBAAA;EAnpBF;EAspBA;IACE,aAAA;EAppBF;EAupBA;IACE,0BAAA;EArpBF;EAwpBA;IACE,WAAA;EAtpBF;AACF;AAypBA;EACE;IACE,sBAAA;EAvpBF;EA0pBA;IACE,sBAAA;EAxpBF;EAupBA;IAII,kBAAA;EAxpBJ;EA4pBA;IACE,WAAA;IACA,YAAA;EA1pBF;EA6pBA;IACE,YAAA;EA3pBF;EA8pBA;IACE,oBAAA;EA5pBF;EA+pBA;IACE,eAAA;EA7pBF;AACF;AAgqBA;EACE,gBAAA;EACA,mBAAA;AA9pBF;AA4pBA;EAKI,gCAAA;EACA,qCAAA;EACA,gCAAA;EACA,gCAAA;EACA,6BAAA;EACA,8BAAA;AA9pBJ;AAopBA;EAcI,8BAAA;AA/pBJ;AACA,yDAAyD;ACv+GzD;EACE,WAAA;ADy+GF;ACt+GA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;ADw+GF;ACr+GA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EACA,wBAAA;EACA,aAAA;ADu+GF;ACr+GE;EACE,kCAAA;EACA,2CAAA;EACA,mBAAA;ADu+GJ;ACn+GA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;ADq+GF;ACn+GE;EACE,kCAAA;EACA,mBAAA;ADq+GJ;ACj+GA;EACE,qBAAA;ADm+GF;ACh+GA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;ADk+GF;AC/9GA;EACE,cAAA;EACA,qBAAA;EACA,sBAAA;ADi+GF;AC99GA;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;ADg+GF;AC99GE;EACE,UAAA;ADg+GJ;AC59GA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;AD89GF;AC39GA;EACE,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,sCAAA;EACA,8CAAA;AD69GF;AC19GA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,qBAAA;EACA,4CAAA;AD49GF;ACz9GA;EACE,kBAAA;EACA,8BAAA;AD29GF;ACx9GA;EACE,WAAA;EACA,wBAAA;EACA,mBAAA;AD09GF;ACv9GA;EACE,qBAAA;EACA,yCAAA;EACA,4CAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;ADy9GF;ACt9GA;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;ADw9GF","sourcesContent":["@navy: #07337f;\n@navy-deep: #052862;\n@primary: #2379f4;\n@primary-hover: #1267dc;\n@sky: #edf7ff;\n@surface: #ffffff;\n@border: #d9e5f2;\n@text: #1d2b3c;\n@muted: #68788e;\n@success: #16833b;\n@danger: #e43045;\n@warning: #f1a62a;\n@radius: 6px;\n@radius-lg: 10px;\n@shadow: 0 8px 28px fade(@navy-deep, 8%);\n\n.surface-card() {\n  background: @surface;\n  border: 1px solid @border;\n  border-radius: @radius-lg;\n  box-shadow: @shadow;\n}\n\n.focus-ring() {\n  outline: none;\n  border-color: @primary;\n  box-shadow: 0 0 0 3px fade(@primary, 16%);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --color-bg: @sky;\n  --color-surface: @surface;\n  --color-border: @border;\n  --color-text: @text;\n  --color-text-muted: @muted;\n  --color-primary: @primary;\n  --color-primary-hover: @primary-hover;\n  --color-primary-light: #e8f2ff;\n  --color-success: @success;\n  --color-success-bg: #e7f6eb;\n  --color-error: @danger;\n  --color-error-bg: #fff0f2;\n  --color-warning: @warning;\n  --radius: @radius;\n  --radius-lg: @radius-lg;\n  --shadow: @shadow;\n  --font: Inter, 'Segoe UI', Roboto, Arial, sans-serif;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  font-family: var(--font);\n  background: var(--color-bg);\n  color: var(--color-text);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ── Buttons ── */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.55rem 1.1rem;\n  border: 1px solid transparent;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  font-family: inherit;\n}\n\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Self-contained so it also looks right without the .btn base class. */\n.btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 36px;\n  padding: 0.55rem 1.1rem;\n  border: 1px solid transparent;\n  border-radius: var(--radius);\n  background: var(--color-primary);\n  color: #fff;\n  font: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--color-primary-hover);\n}\n\n.btn-primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Self-contained so it also looks right without the .btn base class. */\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 36px;\n  padding: 0.55rem 1.1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: var(--color-bg);\n}\n\n.btn-secondary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.btn-ghost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  min-height: 36px;\n  padding: 0.55rem 1.1rem;\n  border: 1px solid transparent;\n  border-radius: var(--radius);\n  background: transparent;\n  color: var(--color-text-muted);\n  font: inherit;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background: var(--color-bg);\n  color: var(--color-text);\n  border-color: var(--color-border);\n}\n\n.btn-ghost:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.btn-full {\n  width: 100%;\n}\n\n/* ── Logo ── */\n\n.logo-mark {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius);\n  background: var(--color-primary);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 0.85rem;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.logo-mark.sm {\n  width: 32px;\n  height: 32px;\n  font-size: 0.75rem;\n}\n\n/* ── Login ── */\n\n.login-page {\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: linear-gradient(160deg, #e8f1f8 0%, var(--color-bg) 50%);\n}\n\n.login-card {\n  width: 100%;\n  max-width: 400px;\n  background: var(--color-surface);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  padding: 2rem;\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 1.75rem;\n}\n\n.login-header .logo-mark {\n  margin: 0 auto 1rem;\n}\n\n.login-header h1 {\n  font-size: 1.35rem;\n  font-weight: 600;\n}\n\n.login-header p {\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  margin-top: 0.25rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.login-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n}\n\n.login-form input {\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  font-family: inherit;\n  transition: border-color 0.15s;\n}\n\n.login-form input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px var(--color-primary-light);\n}\n\n.login-divider {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin: 1.25rem 0;\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n}\n\n.login-divider::before,\n.login-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--color-border);\n}\n\n/* ── Alerts ── */\n\n.alert {\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.alert-error {\n  background: var(--color-error-bg);\n  color: var(--color-error);\n  border: 1px solid #f5c6c2;\n}\n\n.alert-success {\n  background: var(--color-success-bg);\n  color: var(--color-success);\n  border: 1px solid #b8dfc9;\n}\n\n/* ── Layout ── */\n\n.app-layout {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.5rem;\n  background: var(--color-surface);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.user-menu {\n  position: relative;\n}\n\n.user-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n  background: none;\n  border: none;\n  padding: 0.25rem 0.4rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.user-label:hover,\n.user-label.is-open {\n  color: var(--color-text);\n  background: var(--color-bg);\n}\n\n.user-menu-panel {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  right: 0;\n  z-index: 80;\n  min-width: 240px;\n  padding: 0.85rem 1rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n}\n\n.user-menu-title {\n  margin: 0 0 0.65rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.user-menu-details {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.user-menu-details > div {\n  display: grid;\n  grid-template-columns: 4.5rem 1fr;\n  gap: 0.5rem;\n  align-items: baseline;\n}\n\n.user-menu-details dt {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n}\n\n.user-menu-details dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  word-break: break-word;\n}\n\n.user-menu-muted {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.user-menu-error {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #b91c1c;\n}\n\n.app-nav {\n  display: flex;\n  gap: 0.25rem;\n  padding: 0.5rem 1.5rem;\n  background: var(--color-surface);\n  border-bottom: 1px solid var(--color-border);\n}\n\n.nav-link {\n  padding: 0.45rem 0.9rem;\n  border-radius: var(--radius);\n  text-decoration: none;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: background 0.15s, color 0.15s;\n}\n\n.nav-link:hover {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.nav-link-primary {\n  color: var(--color-primary);\n  background: var(--color-primary-light);\n}\n\n.nav-link-primary:hover {\n  background: #d4e6f3;\n  color: var(--color-primary-hover);\n}\n\n.app-main {\n  flex: 1;\n  padding: 1.5rem;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n/* ── Page ── */\n\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n\n.page-header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.page-subtitle {\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  margin-top: 0.15rem;\n}\n\n.result-count {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n  padding-top: 0.35rem;\n}\n\n/* ── Dashboard overview ── */\n\n.dashboard-overview {\n  margin-bottom: 1rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.dashboard-overview-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.75rem;\n}\n\n.dashboard-overview-toggle {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: baseline;\n  gap: 0.65rem 1rem;\n  flex: 1 1 14rem;\n  min-width: 0;\n  padding: 0.85rem 1rem;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  color: inherit;\n}\n\n.dashboard-overview-toggle:hover {\n  background: #f7faff;\n}\n\n.dashboard-overview-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.5rem 0.75rem;\n  padding: 0.45rem 1rem 0.65rem;\n}\n\n.dashboard-overview-title {\n  font-size: 0.95rem;\n  font-weight: 650;\n  color: #243447;\n}\n\n.dashboard-overview-subtitle {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.dashboard-overview-chevron {\n  font-size: 0.85rem;\n  color: #5e6f84;\n  justify-self: end;\n}\n\n.dashboard-overview-body {\n  padding: 0 1rem 1rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.overview-scope-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem 1rem;\n  margin-top: 0.85rem;\n}\n\n.overview-scope-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  min-width: 0;\n  max-width: 100%;\n  flex: 1 1 14rem;\n}\n\n.overview-scope-field-compact {\n  flex: 1 1 8.5rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.overview-scope-field-compact .overview-scope-select {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.overview-scope-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.overview-scope-select {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 0.4rem 0.55rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: #fff;\n  font: inherit;\n  font-size: 0.875rem;\n  color: var(--color-text);\n}\n\n.overview-scope-hint {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  padding-bottom: 0.35rem;\n}\n\n.overview-scope-hint-error {\n  color: var(--color-error, #e43045);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.overview-status {\n  margin: 0.85rem 0 0;\n  font-size: 0.875rem;\n  color: var(--color-text-muted);\n}\n\n.overview-status-error {\n  color: var(--color-error, #e43045);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.overview-metric-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(9.5rem, 1fr));\n  gap: 0.75rem;\n  margin-top: 0.9rem;\n}\n\n.overview-metric {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.7rem 0.8rem;\n  border: 1px solid #e7eef6;\n  border-radius: var(--radius-md, 8px);\n  background: #fbfcfe;\n  min-height: 4.25rem;\n}\n\n.overview-metric-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #5e6f84;\n}\n\n.overview-metric-value {\n  font-size: 1.25rem;\n  font-weight: 650;\n  color: #243447;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n}\n\n.overview-metric-hint {\n  font-size: 0.72rem;\n  color: var(--color-text-muted);\n}\n\n.overview-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.75rem;\n}\n\n/* ── Filters ── */\n\n.filters-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  align-items: flex-end;\n  padding: 1rem;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  margin-bottom: 1rem;\n}\n\n.filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  min-width: 0;\n  max-width: 100%;\n}\n\n.filter-field input,\n.filter-field select {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 0.45rem 0.6rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font-size: 0.9rem;\n  font-family: inherit;\n  background: var(--color-surface);\n}\n\n.filter-field input[type='date']::-webkit-datetime-edit {\n  min-width: 0;\n}\n\n.filter-field input:focus,\n.filter-field select:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n.filter-field-grow {\n  flex: 1 1 220px;\n  min-width: min(100%, 200px);\n}\n\n.filter-clear {\n  align-self: flex-end;\n  margin-bottom: 1px;\n}\n\n/* ── Table ── */\n\n.table-wrap {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.referrals-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.referrals-table th {\n  text-align: left;\n  padding: 0.75rem 1rem;\n  background: var(--color-bg);\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.referrals-table td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.referrals-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.referrals-table tbody tr:hover {\n  background: #fafbfc;\n}\n\n.status-with-overdue {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.referrals-table th.col-date,\n.referrals-table td.col-date {\n  min-width: 8rem;\n}\n\n.referrals-table th.col-datetime,\n.referrals-table td.col-datetime {\n  min-width: 11rem;\n  white-space: nowrap;\n}\n\n.referrals-table th.col-created-by,\n.referrals-table td.col-created-by {\n  min-width: 8rem;\n}\n\n.referrals-table th.col-owner,\n.referrals-table td.col-owner {\n  min-width: 8rem;\n}\n\n.referrals-table th.col-issue-type,\n.referrals-table td.col-issue-type {\n  min-width: 12rem;\n  max-width: 18rem;\n}\n\n.referrals-table td.col-issue-type span {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.referrals-table th.col-level,\n.referrals-table td.col-level {\n  min-width: 4.5rem;\n  white-space: nowrap;\n}\n\n.referrals-table th.col-case-id,\n.referrals-table td.col-case-id {\n  min-width: 6rem;\n  white-space: nowrap;\n}\n\n.referrals-table tbody.referral-group.has-children {\n  tr td {\n    border-bottom-color: #d9e4f0;\n  }\n\n  tr:first-child td {\n    border-top: 2px solid #b7c9de;\n  }\n\n  tr:last-child td {\n    border-bottom: 2px solid #b7c9de;\n  }\n\n  tr.is-parent-row td {\n    background: #f4f8fd;\n  }\n\n  tr.is-child-row td {\n    background: #fbfdff;\n  }\n\n  tr.is-child-row td:first-child {\n    padding-left: 1.5rem;\n    box-shadow: inset 3px 0 0 #7ea3c7;\n  }\n}\n\n.referrals-table tbody.referral-group + tbody.referral-group tr:first-child td {\n  border-top-width: 2px;\n}\n\n.child-parent-hint {\n  margin-top: 0.15rem;\n  color: @muted;\n  font-size: 0.72rem;\n  font-weight: 500;\n}\n\n.referral-card-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.referral-card-group.has-children {\n  padding: 0.45rem;\n  border: 2px solid #b7c9de;\n  border-radius: var(--radius-lg);\n  background: #f7faff;\n}\n\n.referral-card-group .referral-card {\n  margin: 0;\n}\n\n.referral-card.is-child-row {\n  margin-left: 0;\n  border-left: 3px solid #7ea3c7;\n}\n\n.th-label {\n  display: inline-flex;\n  min-height: 32px;\n  align-items: center;\n}\n\n.referrals-table th.col-status,\n.referrals-table td.col-status {\n  min-width: 10rem;\n  width: auto;\n}\n\n.referral-overdue-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.15rem;\n  height: 1.15rem;\n  border-radius: 50%;\n  background: var(--color-error, #e43045);\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.mono {\n  font-family: 'Cascadia Code', 'Consolas', monospace;\n  font-size: 0.82rem;\n}\n\n.table-empty {\n  padding: 3rem;\n  text-align: center;\n  color: var(--color-text-muted);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n}\n\n.l15-edit-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n\n  p {\n    margin: 0;\n    max-width: 36rem;\n  }\n}\n\n.text-muted {\n  color: var(--color-text-muted);\n}\n\n.referral-id-link {\n  color: var(--color-primary);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.referral-id-link:hover {\n  text-decoration: underline;\n}\n\n/* Mobile card list — shown under 768px; table stays on desktop. */\n.referrals-cards {\n  display: none;\n}\n\n.referrals-cards-sort {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-bottom: 0.75rem;\n}\n\n.referrals-cards-sort .th-sort {\n  padding: 0.4rem 0.65rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--color-surface);\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.referrals-cards-sort .th-sort-active {\n  border-color: var(--color-primary);\n  background: #edf6ff;\n  color: var(--color-primary);\n}\n\n.referrals-card-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.referral-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 0.9rem 1rem;\n}\n\n.referral-card-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.referral-card-head .referral-id-link {\n  font-size: 1rem;\n}\n\n.referral-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem 1.25rem;\n  margin: 0;\n\n  > div {\n    flex: 1 1 7.5rem;\n    min-width: 0;\n  }\n\n  dt {\n    margin: 0 0 0.15rem;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: var(--color-text-muted);\n  }\n\n  dd {\n    margin: 0;\n    font-size: 0.875rem;\n    color: var(--color-text);\n    overflow-wrap: anywhere;\n  }\n}\n\n/* ── Referral detail ── */\n\n.back-link {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n  color: var(--color-text-muted);\n  text-decoration: none;\n  font-size: 0.85rem;\n}\n\n.back-link:hover {\n  color: var(--color-primary);\n}\n\n.referral-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.detail-card {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 1.25rem 1.5rem;\n}\n\n.detail-card h2 {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n}\n\n.scheduled-appointments-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.scheduled-appointment {\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  background: #fafbfd;\n}\n\n.scheduled-appointment .detail-meta {\n  margin: 0;\n}\n\n.detail-card-heading {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n\n  h2 {\n    margin: 0;\n  }\n}\n\n.detail-attachment-upload {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.detail-attachment-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.detail-attachment-upload-btn {\n  font-size: 0.82rem;\n  padding: 0.35rem 0.75rem;\n}\n\n.detail-attachment-success {\n  margin: 0 0 0.75rem;\n  color: var(--color-success, #15803d);\n  font-size: 0.88rem;\n}\n\n.detail-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n  margin: 0;\n}\n\n.detail-meta dt {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--color-text-muted);\n  margin-bottom: 0.2rem;\n}\n\n.detail-meta dd {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.detail-related-links {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.85rem;\n}\n\n.detail-meta a,\n.alert a {\n  color: var(--color-primary);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.detail-meta a:hover,\n.alert a:hover {\n  text-decoration: underline;\n}\n\n.related-incidents-list {\n  display: grid;\n  gap: 0.65rem;\n}\n\n.related-incident-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.8rem 0.95rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  color: var(--color-text);\n  background: #fafcff;\n  text-decoration: none;\n\n  &:hover {\n    border-color: var(--color-primary);\n    background: #f1f7ff;\n  }\n\n  > span {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n  }\n\n  > span:last-child {\n    align-items: flex-end;\n    color: var(--color-text-muted);\n    font-size: 0.8rem;\n    text-align: right;\n  }\n}\n\n.persons-involved-badges {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.person-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  max-width: 100%;\n  padding: 0.4rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-bg, #f8fafc);\n  color: inherit;\n  text-decoration: none;\n  font-size: 0.85rem;\n  line-height: 1.2;\n}\n\n.person-badge.is-patient {\n  border-color: var(--color-primary);\n  border-width: 2px;\n  background: #e8f2ff;\n  box-shadow: 0 0 0 1px fade(#2b6cb0, 12%);\n}\n\na.person-badge:hover {\n  border-color: var(--color-primary);\n  background: #edf6ff;\n}\n\na.person-badge.is-patient:hover {\n  background: #dcecff;\n}\n\n.person-badge-name {\n  font-weight: 600;\n  color: var(--color-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.person-badge-type {\n  flex-shrink: 0;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--color-text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.person-manage-btn {\n  flex-shrink: 0;\n}\n\n.site-value {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  flex-wrap: wrap;\n}\n\n.site-missing {\n  color: var(--color-danger, #b42318);\n  font-weight: 600;\n}\n\n.site-change-btn {\n  min-height: 28px;\n  padding: 0.15rem 0.6rem;\n  font-size: 0.75rem;\n}\n\n/* The editor is wider than one summary column, so give it its own full row. */\n.detail-site-cell.is-editing {\n  grid-column: 1 / -1;\n}\n\n.site-editor {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  max-width: 34rem;\n\n  select {\n    flex: 1 1 16rem;\n    min-width: 0;\n    min-height: 36px;\n    padding: 0.4rem 0.55rem;\n    border: 1px solid var(--color-border);\n    border-radius: var(--radius);\n    background: var(--color-surface);\n    color: var(--color-text);\n    font: inherit;\n    font-size: 0.875rem;\n  }\n\n  .detail-attachment-error {\n    flex: 1 1 100%;\n    margin: 0;\n  }\n}\n\n.site-editor-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.person-editor {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.person-editor-row {\n  display: grid;\n  grid-template-columns:\n    auto\n    repeat(2, minmax(6.5rem, 1fr))\n    repeat(2, minmax(6.5rem, 0.75fr))\n    minmax(9.5rem, 1.1fr)\n    auto;\n  gap: 0.4rem 0.45rem;\n  align-items: end;\n  padding: 0.5rem 0.55rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-bg, #f8fafc);\n\n  .person-user-picker {\n    align-self: end;\n  }\n\n  label {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    min-width: 0;\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: var(--color-text-muted);\n  }\n\n  input,\n  select {\n    width: 100%;\n    min-height: 2rem;\n    padding: 0.3rem 0.45rem;\n    border: 1px solid var(--color-border);\n    border-radius: 6px;\n    background: #fff;\n    color: var(--color-text);\n    font: inherit;\n    font-size: 0.88rem;\n    font-weight: 400;\n  }\n}\n\n.person-remove-btn {\n  min-height: 2rem;\n  padding: 0.3rem 0.55rem;\n  border: 1px solid #e5a6a6;\n  border-radius: 6px;\n  background: #fff5f5;\n  color: #a52828;\n  font-size: 0.82rem;\n  cursor: pointer;\n}\n\n.site-user-picker {\n  position: relative;\n  display: flex;\n  flex: none;\n  align-items: center;\n}\n\n.site-user-picker-trigger {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  padding: 0;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: #fff;\n  color: var(--color-text-muted);\n  cursor: pointer;\n\n  svg {\n    width: 1.1rem;\n    height: 1.1rem;\n  }\n\n  &:hover:not(:disabled) {\n    border-color: var(--color-primary);\n    color: var(--color-primary);\n    background: var(--color-primary-light);\n  }\n\n  &.is-selected,\n  &.is-open {\n    border-color: var(--color-primary);\n    color: var(--color-primary);\n    background: var(--color-primary-light);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n}\n\n.site-user-picker-menu {\n  position: fixed;\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  padding: 0.4rem;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  background: var(--color-surface, #fff);\n  box-shadow: 0 10px 24px fade(#000, 12%);\n  overflow: hidden;\n}\n\n.site-user-picker-search {\n  flex: none;\n  width: 100%;\n  min-height: 2rem;\n  margin-bottom: 0.3rem;\n  padding: 0.3rem 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: #fff;\n  color: var(--color-text);\n  font: inherit;\n  font-size: 0.85rem;\n}\n\n.site-user-picker-options {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  flex: 1 1 auto;\n  overflow: auto;\n  min-height: 0;\n}\n\n.site-user-picker-option {\n  appearance: none;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.05rem;\n  padding: 0.4rem 0.5rem;\n  border: 0;\n  border-radius: 5px;\n  background: transparent;\n  color: var(--color-text);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.site-user-picker-option.is-active,\n.site-user-picker-option:hover {\n  background: fade(#2b6cb0, 8%);\n}\n\n.site-user-picker-option.is-current {\n  box-shadow: inset 2px 0 0 var(--color-primary);\n}\n\n.site-user-picker-option.is-clear {\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n}\n\n.site-user-picker-option-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.site-user-picker-option-email,\n.site-user-picker-option-meta {\n  color: var(--color-text-muted);\n  font-size: 0.75rem;\n  font-weight: 400;\n  word-break: break-word;\n}\n\n.site-user-picker-empty {\n  padding: 0.55rem 0.5rem;\n  color: var(--color-text-muted);\n  font-size: 0.82rem;\n}\n\n.person-editor-actions,\n.person-editor-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.person-editor-actions {\n  justify-content: space-between;\n}\n\n@media (max-width: 900px) {\n  .person-editor-row {\n    grid-template-columns: auto repeat(2, minmax(0, 1fr));\n\n    .person-user-picker {\n      grid-row: 1 / span 2;\n      align-self: start;\n      margin-top: 1.15rem;\n    }\n\n    .person-remove-btn {\n      justify-self: start;\n    }\n  }\n}\n\n@media (max-width: 560px) {\n  .person-editor-row {\n    grid-template-columns: auto 1fr;\n\n    .person-user-picker {\n      grid-row: 1;\n      margin-top: 1.15rem;\n    }\n\n    label,\n    .person-remove-btn {\n      grid-column: 2;\n    }\n  }\n\n  .person-editor-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .person-editor-actions-right {\n    justify-content: flex-end;\n  }\n}\n\n.referral-updates-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.referral-updates-new-count {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 0.55rem;\n  padding: 0.12rem 0.5rem;\n  border-radius: 999px;\n  background: #edf6ff;\n  border: 1px solid fade(#2b6cb0, 28%);\n  color: var(--color-primary, #2b6cb0);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n\n.referral-update {\n  --update-accent: var(--color-border);\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-left: 3px solid var(--update-accent);\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-bg, #f8fafc);\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.referral-update--l1-processor {\n  --update-accent: #2b6cb0;\n}\n\n.referral-update--esd113 {\n  --update-accent: #9b2c2c;\n}\n\n.referral-update--adjuster {\n  --update-accent: #2b6cb0;\n}\n\n.referral-update--admin {\n  --update-accent: #6b46c1;\n}\n\n.referral-update--provider {\n  --update-accent: #2f855a;\n}\n\n.referral-update--manager {\n  --update-accent: #c05621;\n}\n\n.referral-update--inspire {\n  --update-accent: #319795;\n}\n\n.referral-update--school-building {\n  --update-accent: #2379f4;\n}\n\n.referral-update--system {\n  --update-accent: #718096;\n}\n\n.referral-update.is-new {\n  background: #f3f8ff;\n  box-shadow: none;\n}\n\n.referral-update-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.35rem 1rem;\n  margin-bottom: 0.45rem;\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n\n  time {\n    font-weight: 600;\n    color: var(--color-text);\n  }\n}\n\n.referral-update-meta-left {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.referral-update-type {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.06rem 0.4rem;\n  border-radius: 4px;\n  border: 1px solid fade(#000, 8%);\n  background: fade(#fff, 70%);\n  color: var(--update-accent, var(--color-text-muted));\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.referral-update-meta-right {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.referral-update-new-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.08rem 0.4rem;\n  border-radius: 999px;\n  background: var(--color-primary, #2b6cb0);\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.referral-update-by {\n  &::before {\n    content: 'by ';\n    font-weight: 400;\n    color: var(--color-text-muted);\n  }\n}\n\n.referral-update-tags {\n  list-style: none;\n  margin: 0 0 0.45rem;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.referral-update-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.08rem 0.45rem;\n  border-radius: 999px;\n  background: fade(#2b6cb0, 10%);\n  border: 1px solid fade(#2b6cb0, 22%);\n  color: #2b6cb0;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.referral-update-description {\n  margin: 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--color-text);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.referral-update-mention {\n  display: inline;\n  padding: 0 0.15rem;\n  border-radius: 3px;\n  background: fade(#2b6cb0, 12%);\n  color: #2b6cb0;\n  font-weight: 700;\n}\n\n.referral-updates-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.85rem;\n  padding-top: 0.75rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.referral-post-update-btn {\n  appearance: none;\n  border: 1px solid var(--color-border);\n  background: transparent;\n  color: var(--color-text-muted);\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.4rem 0.85rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.referral-post-update-btn:hover {\n  color: var(--color-text);\n  border-color: fade(#2b6cb0, 35%);\n  background: fade(#2b6cb0, 4%);\n}\n\n.referral-post-update-btn:focus-visible {\n  outline: none;\n  border-color: var(--color-primary, #2b6cb0);\n  box-shadow: 0 0 0 3px fade(#2b6cb0, 16%);\n}\n\n.referral-tasks-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.referral-task {\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-left: 3px solid #2b6cb0;\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-bg, #f8fafc);\n}\n\n.referral-task.is-done {\n  border-left-color: #2f855a;\n  background: fade(#2f855a, 4%);\n}\n\n.referral-task-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem 1rem;\n}\n\n.referral-task-title {\n  margin: 0 0 0.3rem;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--color-text);\n}\n\n.referral-task-meta {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.85rem;\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n}\n\n.referral-task-status {\n  font-weight: 700;\n  color: #2b6cb0;\n\n  &.is-done {\n    color: #2f855a;\n  }\n}\n\n.referral-task-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  align-items: center;\n}\n\n.referral-task-updates {\n  list-style: none;\n  margin: 0.7rem 0 0;\n  padding: 0.65rem 0 0;\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.referral-task-update {\n  padding: 0.45rem 0 0;\n}\n\n.detail-task-select {\n  display: block;\n  width: 100%;\n  min-height: 2.5rem;\n  margin: 0 0 0.75rem;\n  padding: 0.45rem 0.55rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: #fff;\n  color: var(--color-text);\n  font: inherit;\n}\n\n/* ── Form tiles ── */\n\n.form-tile-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.form-tile {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.85rem;\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  background: var(--color-surface);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.05s;\n}\n\n.form-tile:hover {\n  border-color: var(--color-primary);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n}\n\n.form-tile:active {\n  transform: translateY(1px);\n}\n\n.form-tile-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  flex-shrink: 0;\n  border-radius: var(--radius);\n  background: var(--color-primary-light);\n  color: var(--color-primary);\n}\n\n.form-tile-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.form-tile-title {\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.3;\n}\n\n.form-tile-source {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.form-tile-meta {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n/* ── Detail attachments ── */\n\n.detail-attachment-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n}\n\n@media (min-width: 576px) {\n  .detail-attachment-list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 768px) {\n  .detail-attachment-list {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.detail-attachment-item {\n  display: flex;\n  align-items: flex-start;\n  min-width: 0;\n  gap: 0.75rem;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-bg, #f8fafc);\n}\n\n.detail-attachment-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: var(--radius, 6px);\n  background: var(--color-primary-light, #e0f2fe);\n  color: var(--color-primary);\n}\n\n.detail-attachment-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.detail-attachment-name {\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  word-break: break-word;\n}\n\nbutton.detail-attachment-link {\n  color: var(--color-primary);\n  text-decoration: none;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-align: left;\n  cursor: pointer;\n  word-break: break-word;\n}\n\nbutton.detail-attachment-link:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\nbutton.detail-attachment-link:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.detail-attachment-download {\n  align-self: flex-start;\n  margin-top: 0.2rem;\n  padding: 0;\n  border: none;\n  background: none;\n  color: var(--color-primary);\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.detail-attachment-download:hover:not(:disabled) {\n  color: var(--color-primary-dark, var(--color-primary));\n}\n\n.detail-attachment-download:disabled {\n  opacity: 0.7;\n  cursor: wait;\n}\n\n.detail-attachment-error {\n  margin: 0 0 0.75rem;\n  color: var(--color-error);\n  font-size: 0.85rem;\n}\n\n.detail-attachment-meta {\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n}\n\n.detail-forms-hint {\n  margin: 0 0 0.75rem;\n}\n\n/* ── Form modal ── */\n\n.form-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 3vh 1rem;\n  background: rgba(15, 23, 42, 0.45);\n  overflow-y: auto;\n}\n\n.form-modal {\n  width: 100%;\n  max-width: 920px;\n  background: var(--color-bg);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  max-height: 94vh;\n}\n\n.form-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--color-border);\n  background: var(--color-surface);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.form-modal-header h2 {\n  margin: 0;\n  font-size: 1.05rem;\n}\n\n.form-modal-source {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n}\n\n.form-modal-close {\n  border: none;\n  background: none;\n  font-size: 1.1rem;\n  line-height: 1;\n  padding: 0.35rem 0.5rem;\n  border-radius: var(--radius);\n  cursor: pointer;\n  color: var(--color-text-muted);\n}\n\n.form-modal-close:hover {\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.form-modal-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.quill-html-display {\n  padding: 0.55rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: #fafbfc;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n\n  p {\n    margin: 0 0 0.5em;\n  }\n\n  p:last-child {\n    margin-bottom: 0;\n  }\n\n  ul,\n  ol {\n    margin: 0.35em 0 0.35em 1.25em;\n    padding: 0;\n  }\n\n  a {\n    color: var(--color-primary);\n  }\n\n  .quill-html-empty {\n    margin: 0;\n    color: var(--color-text-muted);\n  }\n}\n\n.form-modal-body {\n  overflow-y: auto;\n  padding: 0.5rem 1rem 1rem;\n}\n\n.form-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.65rem;\n  padding: 0.85rem 1.25rem;\n  border-top: 1px solid var(--color-border);\n  background: var(--color-surface);\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n/* ── Pagination ── */\n\n.pagination {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.pagination-info {\n  grid-column: 1;\n  justify-self: start;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-controls {\n  grid-column: 2;\n  justify-self: center;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.pagination-page {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-controls .btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-pages {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.pagination-page-btn {\n  min-width: 2rem;\n  height: 2rem;\n  padding: 0 0.5rem;\n  border: 1px solid var(--color-border);\n  background: var(--color-surface, #fff);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  color: var(--color-text, #0f172a);\n  cursor: pointer;\n}\n\n.pagination-page-btn:hover:not(:disabled):not(.active) {\n  background: var(--color-bg);\n}\n\n.pagination-page-btn.active {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  color: #fff;\n  font-weight: 600;\n}\n\n.pagination-page-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-gap {\n  padding: 0 0.25rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-jump {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.pagination-jump input {\n  width: 4rem;\n  height: 2rem;\n  padding: 0 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n}\n\n/* Sortable column headers */\n.referrals-table th {\n  padding: 0;\n}\n\n.th-sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.th-sort:hover {\n  color: var(--color-text, #0f172a);\n}\n\n.th-sort-active {\n  color: var(--color-primary);\n}\n\n.th-sort-arrow {\n  font-size: 0.7rem;\n  opacity: 0.5;\n}\n\n.th-sort-active .th-sort-arrow {\n  opacity: 1;\n}\n\n/* ── Badges ── */\n\n.status-badge,\n.type-badge {\n  display: inline-block;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status-0 {\n  background: var(--color-primary-light);\n  color: var(--color-primary);\n}\n\n.status-1 {\n  background: #fef9e7;\n  color: var(--color-warning);\n}\n\n.status-2 {\n  background: var(--color-success-bg);\n  color: var(--color-success);\n}\n\n.status-3 {\n  background: #f0f0f5;\n  color: #555;\n}\n\n/* ── Tabs ── */\n\n.tab-bar {\n  display: flex;\n  gap: 0.25rem;\n  margin-bottom: 1.25rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.tab {\n  padding: 0.6rem 1.1rem;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.15s;\n}\n\n.tab:hover {\n  color: var(--color-text);\n}\n\n.tab.active {\n  color: var(--color-primary);\n  border-bottom-color: var(--color-primary);\n}\n\n/* ── Form switcher (referral + added supporting forms) ── */\n\n.form-switcher {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  margin: -0.5rem 0 1.25rem;\n}\n\n.form-switcher-item {\n  display: inline-flex;\n  align-items: stretch;\n  max-width: 100%;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-surface, #fff);\n  overflow: hidden;\n}\n\n.form-switcher-item.active {\n  border-color: var(--color-primary);\n  background: #eef2ff;\n}\n\n.form-switcher-tab {\n  padding: 0.45rem 0.9rem;\n  border: 1px solid var(--color-border);\n  border-radius: 999px;\n  background: var(--color-surface, #fff);\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\n}\n\n.form-switcher-item .form-switcher-tab {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n\n.form-switcher-item.active .form-switcher-tab {\n  color: var(--color-primary);\n}\n\n.form-switcher-tab:hover {\n  color: var(--color-text);\n  border-color: var(--color-text-muted);\n}\n\n.form-switcher-tab.active {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n  background: #eef2ff;\n}\n\n.form-switcher-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.6rem;\n  padding: 0 0.45rem 0 0.15rem;\n  border: 0;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.form-switcher-remove:hover {\n  color: var(--color-error, #e43045);\n}\n\n.form-switcher-tab--add {\n  border-style: dashed;\n}\n\n.form-switcher-tab--add.is-open,\n.form-switcher-tab--add:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.add-form-menu {\n  position: relative;\n}\n\n.add-form-menu-list {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  left: 0;\n  z-index: 60;\n  min-width: 16rem;\n  max-width: min(22rem, 80vw);\n  margin: 0;\n  padding: 0.35rem;\n  list-style: none;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg, 10px);\n  background: var(--color-surface, #fff);\n  box-shadow: var(--shadow);\n}\n\n.add-form-menu-option {\n  display: block;\n  width: 100%;\n  padding: 0.55rem 0.7rem;\n  border: 0;\n  border-radius: var(--radius, 6px);\n  background: transparent;\n  color: var(--color-text);\n  font: inherit;\n  font-size: 0.85rem;\n  text-align: left;\n  cursor: pointer;\n}\n\n.add-form-menu-option:hover {\n  background: #eef2ff;\n  color: var(--color-primary);\n}\n\n/* New Referral: compact sticky chrome + form switcher */\n.page--new-referral {\n  .new-referral-chrome {\n    position: sticky;\n    top: 0;\n    z-index: 50;\n    margin: -0.35rem 0 0.85rem;\n    padding: 0.35rem 0 0.65rem;\n    background: var(--color-bg);\n    border-bottom: 1px solid var(--color-border);\n    box-shadow: 0 8px 12px -10px fade(@navy, 18%);\n  }\n\n  .page-header--compact {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 0.35rem 0.75rem;\n    margin-bottom: 0.35rem;\n\n    h1 {\n      font-size: 1.05rem;\n      font-weight: 700;\n      letter-spacing: -0.02em;\n      line-height: 1.2;\n    }\n\n    .page-subtitle {\n      margin: 0;\n      font-size: 0.8rem;\n      line-height: 1.3;\n      color: var(--color-text-muted);\n    }\n  }\n\n  .tab-bar {\n    margin-bottom: 0.5rem;\n  }\n\n  .tab {\n    padding: 0.4rem 0.85rem;\n    font-size: 0.82rem;\n  }\n\n  .form-switcher {\n    margin: 0;\n    gap: 0.35rem;\n  }\n\n  .form-switcher-tab {\n    padding: 0.3rem 0.7rem;\n    font-size: 0.78rem;\n  }\n\n  .form-switcher-remove {\n    min-width: 1.35rem;\n    font-size: 0.95rem;\n  }\n\n  .add-form-menu-option {\n    font-size: 0.8rem;\n  }\n}\n\n.form-load-error {\n  padding: 2rem;\n  text-align: center;\n  color: var(--color-error);\n}\n\n.form-load-error p {\n  margin-bottom: 1rem;\n}\n\n/* ── SurveyJS overrides ── */\n\n.survey-container {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 1.5rem;\n  position: relative;\n}\n\n.survey-container .sd-root-modern {\n  --sjs-primary-backcolor: var(--color-primary);\n  --sjs-primary-backcolor-dark: var(--color-primary-hover);\n  --sjs-general-backcolor: var(--color-surface);\n  --sjs-border-default: var(--color-border);\n}\n\n.overlay-msg {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.78);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  z-index: 10;\n  border-radius: var(--radius-lg);\n}\n\n/* Pin to the viewport so long forms still show the spinner on-screen. */\n.overlay-msg--viewport {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  border-radius: 0;\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.overlay-msg-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  padding: 1.25rem 1.5rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.18);\n  color: var(--color-text);\n  font-size: 0.95rem;\n}\n\n.overlay-msg-content .spinner {\n  width: 36px;\n  height: 36px;\n}\n\n/* ── Upload ── */\n\n.upload-panel {\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n}\n\n.upload-test-note {\n  margin: 1rem 0 0;\n  font-size: 0.875rem;\n  color: var(--color-text-muted, #64748b);\n}\n\n.upload-test-note code {\n  font-size: 0.8125rem;\n}\n\n.upload-dropzone input[type='file'] {\n  display: none;\n}\n\n.upload-dropzone label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 3rem 2rem;\n  border: 2px dashed var(--color-border);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.upload-dropzone label:hover {\n  border-color: var(--color-primary);\n  background: var(--color-primary-light);\n}\n\n.upload-dropzone strong {\n  font-size: 1rem;\n}\n\n.upload-dropzone span {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n}\n\n.upload-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n}\n\n/* ── Loading ── */\n\n.loading-screen {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  color: var(--color-text-muted);\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--color-border);\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ── Responsive ── */\n\n@media (max-width: 768px) {\n  .app-main {\n    padding: 1rem;\n    min-width: 0;\n    overflow-x: hidden;\n  }\n\n  .page {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .filters-panel,\n  .dashboard-overview,\n  .overview-scope-row,\n  .dashboard-overview-controls {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .filters-bar {\n    flex-direction: column;\n    align-items: stretch;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .filter-field,\n  .filter-field-grow,\n  .filter-level-chips,\n  .overview-scope-field,\n  .overview-scope-field-compact {\n    flex: 1 1 100%;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .referrals-table-desktop {\n    display: none;\n  }\n\n  .referrals-cards {\n    display: block;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n/* ── Figma-aligned visual system ── */\n\nbody {\n  background: @sky;\n  font-size: 14px;\n}\n\na,\nbutton,\ninput,\nselect,\ntextarea {\n  &:focus-visible {\n    outline: 3px solid fade(@primary, 28%);\n    outline-offset: 2px;\n  }\n}\n\n.btn {\n  min-height: 36px;\n  padding: 0.55rem 1.15rem;\n  border-radius: 6px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n\n  &:active:not(:disabled) {\n    transform: translateY(1px);\n  }\n}\n\n.btn-primary {\n  background: @primary;\n  box-shadow: 0 4px 10px fade(@primary, 20%);\n}\n\n.btn-secondary {\n  color: @navy;\n  border-color: #c8d6e5;\n  box-shadow: 0 1px 2px fade(@navy-deep, 6%);\n\n  &:hover:not(:disabled) {\n    border-color: fade(@primary, 55%);\n    background: @sky;\n    color: @primary;\n    box-shadow: 0 2px 8px fade(@primary, 14%);\n  }\n\n  &:active:not(:disabled) {\n    background: darken(@sky, 2%);\n    box-shadow: none;\n    transform: translateY(1px);\n  }\n\n  &:disabled {\n    box-shadow: none;\n  }\n}\n\n.btn-ghost {\n  color: @navy;\n  background: transparent;\n  border: 1px solid transparent;\n  box-shadow: none;\n\n  &:hover:not(:disabled) {\n    color: @primary;\n    background: @sky;\n    border-color: #c8d6e5;\n  }\n\n  &:active:not(:disabled) {\n    background: darken(@sky, 2%);\n    transform: translateY(1px);\n  }\n\n  &:disabled {\n    box-shadow: none;\n  }\n}\n\n/* Login */\n\n.login-page {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(420px, 576px);\n  min-height: 100vh;\n  padding: 0;\n  background: @surface;\n}\n\n.login-visual {\n  position: relative;\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: clamp(2rem, 4vw, 4rem);\n  color: #fff;\n  background: #0b1932;\n\n  &::before {\n    position: absolute;\n    inset: 0;\n    background-image:\n      linear-gradient(fade(#fff, 3%) 1px, transparent 1px),\n      linear-gradient(90deg, fade(#fff, 3%) 1px, transparent 1px);\n    background-size: 46px 46px;\n    content: '';\n    -webkit-mask-image: linear-gradient(to bottom, #000, transparent 85%);\n    mask-image: linear-gradient(to bottom, #000, transparent 85%);\n  }\n\n  p {\n    position: relative;\n    z-index: 1;\n    margin: 0;\n    color: fade(#fff, 68%);\n    font-size: 0.85rem;\n    letter-spacing: 0.04em;\n  }\n}\n\n.login-visual-brand {\n  position: relative;\n  z-index: 1;\n  display: block;\n  width: 200px;\n  object-fit: contain;\n}\n\n.login-illustration {\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  filter: drop-shadow(0 28px 45px fade(#000, 24%));\n}\n\n.login-panel {\n  position: relative;\n  display: grid;\n  width: 100%;\n  max-width: 576px;\n  min-height: 100vh;\n  justify-self: end;\n  place-items: center;\n  padding: 3rem clamp(2rem, 5vw, 4.5rem) 5rem;\n}\n\n.login-card {\n  width: 100%;\n  max-width: 430px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.login-header {\n  margin-bottom: 2rem;\n  text-align: center;\n\n  h1 {\n    margin-top: 1.5rem;\n    color: @text;\n    font-size: clamp(1.45rem, 2vw, 1.85rem);\n    font-weight: 700;\n    letter-spacing: -0.025em;\n  }\n\n  p {\n    margin-top: 0.5rem;\n    color: @muted;\n  }\n}\n\n.login-logo {\n  display: inline-block;\n  max-height: 100px;\n  object-fit: contain;\n}\n\n.login-form {\n  gap: 1.15rem;\n\n  label {\n    gap: 0.45rem;\n    color: @text;\n    font-size: 0.8rem;\n    font-weight: 600;\n  }\n\n  input {\n    min-height: 44px;\n    padding: 0.7rem 0.85rem;\n    border-color: #cdd8e4;\n    border-radius: @radius;\n    color: @text;\n\n    &:focus {\n      .focus-ring();\n    }\n  }\n\n  .btn {\n    min-height: 42px;\n    margin-top: 0.25rem;\n  }\n}\n\n.login-divider {\n  margin: 1.4rem 0;\n}\n\n.footer-need-help {\n  position: absolute;\n  right: clamp(2rem, 5vw, 4.5rem);\n  bottom: 1.5rem;\n  left: clamp(2rem, 5vw, 4.5rem);\n  color: @muted;\n  font-size: 0.82rem;\n  text-align: left;\n\n  a {\n    color: #2671ff;\n    font-weight: 500;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n/* Shared shell */\n\n.app-header {\n  position: relative;\n  z-index: 70;\n  min-height: 72px;\n  padding: 0;\n  border: 0;\n  background: @sky;\n  border-bottom: 1px solid @border;\n}\n\n.app-header-inner,\n.app-nav-inner {\n  display: flex;\n  width: 100%;\n  max-width: 1500px;\n  margin: 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  padding-inline: clamp(1rem, 3vw, 2.5rem);\n}\n\n.app-header-inner {\n  position: relative;\n  min-height: 72px;\n}\n\n.header-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  color: @primary;\n  font-size: 0.92rem;\n  text-decoration: none;\n  z-index: 1;\n}\n\n.header-logo {\n  width: auto;\n  height: 34px;\n  object-fit: contain;\n}\n\n.header-client-logo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  height: 52px;\n  object-fit: cover;\n  pointer-events: none;\n}\n\n.header-brand-divider {\n  width: 1px;\n  height: 24px;\n  margin-inline: 0.15rem;\n  background: fade(@primary, 35%);\n}\n\n.header-product {\n  font-weight: 600;\n}\n\n.header-actions {\n  gap: 0.85rem;\n  z-index: 1;\n}\n\n.user-label {\n  color: @primary;\n  border-radius: 999px;\n\n  &:hover,\n  &.is-open {\n    color: @navy;\n    background: fade(@primary, 10%);\n  }\n}\n\n.btn-header {\n  min-height: 32px;\n  padding: 0.35rem 0.9rem;\n  border: 1px solid @primary;\n  color: @primary;\n  background: transparent;\n\n  &:hover {\n    border-color: @navy;\n    color: @navy;\n    background: fade(@primary, 10%);\n  }\n}\n\n.user-menu-panel {\n  .surface-card();\n  top: calc(100% + 0.65rem);\n}\n\n.app-nav {\n  min-height: 52px;\n  padding: 0;\n  background: @surface;\n  border-bottom-color: @border;\n}\n\n.app-nav-inner {\n  min-height: 52px;\n}\n\n.nav-tabs {\n  display: flex;\n  align-self: stretch;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.nav-link {\n  position: relative;\n  display: inline-flex;\n  min-height: 52px;\n  align-items: center;\n  padding: 0.55rem 0.7rem;\n  border-radius: 0;\n  color: @muted;\n  font-size: 0.8rem;\n\n  &::after {\n    position: absolute;\n    right: 0.7rem;\n    bottom: -1px;\n    left: 0.7rem;\n    height: 2px;\n    border-radius: 2px 2px 0 0;\n    background: transparent;\n    content: '';\n  }\n\n  &:hover {\n    color: @primary;\n    background: transparent;\n  }\n\n  &.active {\n    color: @primary;\n\n    &::after {\n      background: @primary;\n    }\n  }\n}\n\n.nav-link-count {\n  margin-left: 0.15rem;\n  color: @muted;\n  font-weight: 400;\n}\n\n.nav-link-primary {\n  min-height: 34px;\n  padding: 0.45rem 1rem;\n  gap: 0.45rem;\n  border-radius: 999px;\n  color: #fff;\n  background: @primary;\n  box-shadow: 0 3px 9px fade(@primary, 20%);\n\n  &::after {\n    display: none;\n  }\n\n  &:hover {\n    color: #fff;\n    background: @primary-hover;\n  }\n}\n\n.nav-new-icon {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.app-main {\n  max-width: 1500px;\n  padding: clamp(1.25rem, 3vw, 2.5rem);\n}\n\n.app-footer {\n  width: 100%;\n  margin-top: auto;\n  padding: 0;\n  border-top: 1px solid #dce7f6;\n  color: #53647b;\n  background: #f3f7ff;\n}\n\n.app-footer-inner {\n  width: 100%;\n\n  margin: 0 auto;\n  text-align: center;\n\n  p {\n    margin: 0;\n    font-size: 0.75rem;\n    line-height: 1.55;\n  }\n\n  a {\n    color: #0b2f73;\n    font-weight: 700;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.app-footer-powered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  width: 100%;\n  margin: 0%;\n  padding: 0.75rem clamp(1rem, 3vw, 2.5rem);\n  background: @navy;\n  color: fade(#fff, 78%);\n}\n\n.app-footer-powered-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.app-footer-powered-logo {\n  width: auto;\n  height: 36px;\n  object-fit: contain;\n}\n\n.app-footer-privacy {\n  max-width: 1180px;\n  margin: 0.3rem auto 0 !important;\n  font-size: 10px !important;\n  line-height: 1.45 !important;\n}\n\n/* Content and data surfaces */\n\n.page-header {\n  margin-bottom: 1.5rem;\n  align-items: center;\n\n  h1 {\n    color: @text;\n    font-size: clamp(1.35rem, 2vw, 1.7rem);\n    font-weight: 700;\n    letter-spacing: -0.025em;\n  }\n}\n\n.page-subtitle {\n  margin-top: 0.3rem;\n  color: @muted;\n}\n\n.result-count {\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  color: @navy;\n  background: #e4f0ff;\n  font-weight: 600;\n}\n\n.filters-panel {\n  margin-bottom: 1rem;\n  border: 1px solid @border;\n  border-radius: @radius-lg;\n  background: @surface;\n  box-shadow: 0 5px 18px fade(@navy, 5%);\n}\n\n.filters-toggle {\n  display: flex;\n  width: 100%;\n  border-radius: @radius-lg @radius-lg 0 0;\n  min-height: 48px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.15rem;\n  border: 0;\n  color: @text;\n  background: @surface;\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n\n  &:hover {\n    background: #f8fbff;\n  }\n}\n\n.filters-toggle-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.filters-toggle-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.filters-icon {\n  width: 17px;\n  height: 17px;\n  color: @primary;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.filters-active-count {\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  color: @primary;\n  background: #e9f3ff;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.filters-chevron {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  color: @primary;\n  background: #e9f3ff;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform 0.15s ease;\n}\n\n.filters-panel:not(.is-expanded) .filters-toggle {\n  border-radius: @radius-lg;\n}\n\n.filters-panel.is-expanded .filters-chevron {\n  transform: rotate(180deg);\n}\n\n.filters-bar {\n  margin: 0;\n  padding: 1rem 1.15rem 1.15rem;\n  border: 0;\n  border-top: 1px solid #e7eef6;\n  border-radius: 0 0 @radius-lg @radius-lg;\n  background: #fbfdff;\n\n  .filter-field {\n    color: @muted;\n    font-size: 0.74rem;\n    font-weight: 600;\n\n    input,\n    select {\n      min-height: 38px;\n      border-color: #cad7e4;\n      border-radius: @radius;\n      color: @text;\n\n      &:focus {\n        .focus-ring();\n      }\n    }\n  }\n}\n\n.filter-actions {\n  display: flex;\n  flex: 1 0 100%;\n  align-self: flex-end;\n  justify-content: flex-end;\n  gap: 0.55rem;\n  margin-top: 0.15rem;\n  margin-left: 0;\n\n  .btn {\n    min-width: 84px;\n  }\n}\n\n.filter-field-multiselect {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.filter-field-label {\n  display: block;\n}\n\n.filter-level-chips {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.level-chip-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.level-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 38px;\n  padding: 0 0.75rem;\n  border: 1px solid #cad7e4;\n  border-radius: 999px;\n  background: #fff;\n  color: @text;\n  font-size: 0.8rem;\n  font-weight: 650;\n  cursor: pointer;\n\n  input {\n    margin: 0;\n  }\n\n  &.is-selected {\n    border-color: @navy;\n    background: #e4f0ff;\n    color: @navy;\n  }\n}\n\n.filter-multiselect-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 38px;\n  padding: 0.4rem 0.7rem;\n  border: 1px solid #cad7e4;\n  border-radius: @radius;\n  background: @surface;\n  color: @text;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n\n  &:hover,\n  &.is-open {\n    border-color: @primary;\n  }\n\n  &:focus-visible {\n    .focus-ring();\n  }\n}\n\n.filter-multiselect-summary {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.filter-multiselect-chevron {\n  flex-shrink: 0;\n  color: @muted;\n}\n\n.filter-multiselect-panel {\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  left: 0;\n  right: 0;\n  z-index: 30;\n  max-height: 16rem;\n  overflow: auto;\n  padding: 0.45rem;\n  background: @surface;\n  border: 1px solid @border;\n  border-radius: @radius-lg;\n  box-shadow: @shadow;\n}\n\n.filter-multiselect-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 0.25rem;\n}\n\n.filter-multiselect-action {\n  min-height: 0;\n  padding: 0.2rem 0.45rem;\n  font-size: 0.78rem;\n}\n\n.filter-multiselect-options {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.filter-multiselect-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding: 0.4rem 0.45rem;\n  border-radius: @radius;\n  color: @text;\n  font-size: 0.84rem;\n  font-weight: 500;\n  cursor: pointer;\n\n  &:hover {\n    background: fade(@primary, 8%);\n  }\n\n  &.is-child {\n    padding-left: 1.35rem;\n    font-weight: 400;\n  }\n\n  input {\n    margin-top: 0.15rem;\n    flex-shrink: 0;\n  }\n}\n\n.table-wrap {\n  border-color: @border;\n  border-top: 1px solid @border;\n  border-radius: @radius-lg;\n  box-shadow: @shadow;\n}\n\n.referrals-table {\n  font-size: 0.82rem;\n\n  th {\n    background: #f7faff;\n    border-color: @border;\n  }\n\n  td {\n    padding: 0.7rem 1rem;\n    border-color: #e7eef6;\n    color: #344357;\n  }\n\n  tbody tr {\n    transition: background 0.12s ease;\n\n    &:hover {\n      background: #f3f8ff;\n    }\n  }\n}\n\n.th-sort {\n  color: #5e6f84;\n  font-size: 0.72rem;\n  letter-spacing: 0.025em;\n}\n\n.referral-id-link {\n  color: #2f64b8;\n}\n\n.status-badge,\n.type-badge {\n  min-width: 58px;\n  padding: 0.22rem 0.55rem;\n  border-radius: 4px;\n  color: #fff;\n  font-size: 0.68rem;\n  letter-spacing: 0.01em;\n  text-align: center;\n}\n\n.detail-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.detail-update-inspire-btn {\n  font-size: 0.82rem;\n  padding: 0.35rem 0.75rem;\n}\n\n.update-inspire-overlay {\n  overflow: visible;\n}\n\n.update-inspire-modal {\n  max-width: 520px;\n  max-height: none;\n  margin-top: 12vh;\n  overflow: visible;\n}\n\n.copy-from-parent-modal {\n  max-width: 560px;\n}\n\n.copy-from-parent-subtitle {\n  margin: 0.25rem 0 0;\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n  font-weight: 400;\n}\n\n.copy-from-parent-section {\n  margin-bottom: 1rem;\n}\n\n.copy-from-parent-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.4rem;\n\n  h3 {\n    margin: 0;\n    font-size: 0.92rem;\n  }\n}\n\n.copy-from-parent-select-all {\n  padding: 0.2rem 0.45rem;\n  font-size: 0.8rem;\n}\n\n.copy-from-parent-list {\n  list-style: none;\n  margin: 0;\n  padding: 0.25rem;\n  max-height: 12rem;\n  overflow: auto;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: #fff;\n}\n\n.copy-from-parent-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  padding: 0.4rem 0.45rem;\n  border-radius: 5px;\n  cursor: pointer;\n\n  &:hover {\n    background: fade(#2b6cb0, 8%);\n  }\n\n  input {\n    margin-top: 0.2rem;\n  }\n}\n\n.copy-from-parent-option-title,\n.copy-from-parent-option-meta {\n  display: block;\n}\n\n.copy-from-parent-option-title {\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.copy-from-parent-option-meta {\n  color: var(--color-text-muted);\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n\n.update-inspire-modal-body,\n.update-inspire-modal .form-modal-body {\n  overflow: visible;\n  padding: 1.1rem 1.25rem 1.25rem;\n}\n\n.detail-update-inspire-label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.update-mention-field {\n  position: relative;\n  margin: 0 0 0.75rem;\n}\n\n.update-mention-field .detail-update-inspire-textarea {\n  margin-bottom: 0;\n}\n\n.update-mention-menu {\n  list-style: none;\n  margin: 0;\n  padding: 0.25rem;\n  position: fixed;\n  z-index: 10000;\n  max-height: 14rem;\n  overflow: auto;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background: var(--color-surface, #fff);\n  box-shadow: 0 8px 20px fade(#000, 10%);\n}\n\n.update-mention-option {\n  appearance: none;\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.45rem 0.55rem;\n  border: 0;\n  border-radius: 4px;\n  background: transparent;\n  color: var(--color-text);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.update-mention-option.is-active,\n.update-mention-option:hover {\n  background: fade(#2b6cb0, 8%);\n}\n\n.update-mention-option-name {\n  font-weight: 600;\n}\n\n.update-mention-option-handle {\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n}\n\n.detail-update-inspire-textarea {\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0 0 0.75rem;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  font: inherit;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  resize: vertical;\n  min-height: 5.5rem;\n  background: var(--color-surface, #fff);\n  color: var(--color-text);\n}\n\n.detail-update-inspire-textarea:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 1px;\n}\n\n.detail-update-inspire-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.status-0 {\n  color: #fff;\n  background: #21833f;\n}\n\n.status-1 {\n  color: #fff;\n  background: #eea62b;\n}\n\n.status-2 {\n  color: #fff;\n  background: #858b95;\n}\n\n.status-3 {\n  color: #fff;\n  background: #eb3349;\n}\n\n.pagination {\n  margin-top: 1.25rem;\n  padding-inline: 0.25rem;\n}\n\n.pagination-controls {\n  gap: 0.45rem;\n}\n\n.pagination-page-btn {\n  border-radius: 5px;\n\n  &.active {\n    background: @primary;\n    border-color: @primary;\n  }\n}\n\n.pagination-jump input {\n  &:focus {\n    .focus-ring();\n  }\n}\n\n/* Details, tabs, forms, and overlays */\n\n.back-link {\n  color: @primary;\n  font-weight: 600;\n}\n\n.referral-detail {\n  gap: 1rem;\n}\n\n.detail-card {\n  .surface-card();\n  padding: 1.35rem 1.5rem;\n\n  h2 {\n    padding-bottom: 0.8rem;\n    border-bottom: 1px solid #e7eef6;\n    color: @text;\n    font-size: 1rem;\n  }\n}\n\n.detail-meta {\n  gap: 1.25rem 1.5rem;\n\n  dt {\n    color: @muted;\n    font-size: 0.7rem;\n    font-weight: 600;\n  }\n\n  dd {\n    color: @text;\n    font-weight: 500;\n  }\n}\n\n.form-tile {\n  border-color: @border;\n  box-shadow: 0 3px 12px fade(@navy-deep, 5%);\n\n  &:hover {\n    border-color: @primary;\n    box-shadow: 0 7px 18px fade(@primary, 12%);\n  }\n}\n\n.form-tile-icon {\n  color: @primary;\n  background: #e6f1ff;\n}\n\n.tab-bar {\n  border-color: @border;\n}\n\n.tab {\n  color: @muted;\n  font-size: 0.82rem;\n  font-weight: 600;\n\n  &.active {\n    color: @primary;\n    border-bottom-color: @primary;\n  }\n}\n\n.survey-container,\n.upload-panel {\n  .surface-card();\n}\n\n.survey-container .sd-root-modern,\n.survey-panel-side .sd-root-modern,\n.form-modal .sd-root-modern {\n  --sjs-primary-backcolor: @primary;\n  --sjs-primary-backcolor-dark: @primary-hover;\n  --sjs-primary-backcolor-light: #e9f3ff;\n  --sjs-general-backcolor: @surface;\n  --sjs-general-forecolor: @text;\n  --sjs-border-default: @border;\n  --sjs-font-family: var(--font);\n}\n\n.upload-dropzone label {\n  border-color: #b9cee3;\n  background: #f8fbff;\n\n  &:hover {\n    border-color: @primary;\n    background: #edf6ff;\n  }\n}\n\n.alert {\n  border-radius: @radius;\n  box-shadow: 0 4px 14px fade(@navy-deep, 5%);\n}\n\n.table-empty,\n.form-load-error {\n  border-color: @border;\n  background: @surface;\n  box-shadow: @shadow;\n}\n\n.form-modal-overlay {\n  background: fade(@navy-deep, 55%);\n  -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3px);\n}\n\n.form-modal {\n  border: 1px solid fade(#fff, 45%);\n  box-shadow: 0 28px 70px fade(@navy-deep, 35%);\n}\n\n.loading-screen {\n  color: @muted;\n  background: @sky;\n}\n\n@media (max-width: 900px) {\n  .login-visual {\n    padding: 2rem;\n  }\n\n  .header-product,\n  .header-brand-divider {\n    display: none;\n  }\n\n  .pagination {\n    grid-template-columns: 1fr;\n    justify-items: center;\n  }\n\n  .pagination-info,\n  .pagination-controls {\n    grid-column: 1;\n  }\n\n  .pagination-controls {\n    width: 100%;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 680px) {\n  .login-page {\n    display: block;\n  }\n\n  .login-visual {\n    min-height: 150px;\n    padding: 1.5rem;\n  }\n\n  .login-panel {\n    min-height: calc(100vh - 150px);\n    padding: 2.25rem 1.25rem 4.5rem;\n  }\n\n  .footer-need-help {\n    right: 1.25rem;\n    left: 1.25rem;\n  }\n\n  .app-header-inner {\n    min-height: 64px;\n  }\n\n  .header-logo {\n    height: 28px;\n  }\n\n  .header-client-logo {\n    width: 44px;\n    height: 44px;\n  }\n\n  .header-product {\n    max-width: 7.5rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .user-label-name {\n    display: inline-block;\n    max-width: 120px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .app-nav-inner {\n    padding-inline: 0.75rem;\n  }\n\n  .nav-link {\n    padding-inline: 0.55rem;\n  }\n\n  .app-main {\n    padding: 1rem 0.75rem 2rem;\n  }\n\n  .filters-panel {\n    margin-bottom: 0.75rem;\n  }\n\n  .filters-bar {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  .filter-actions {\n    width: 100%;\n    justify-content: flex-end;\n    margin-left: 0;\n  }\n\n  .table-wrap {\n    border-top: 1px solid @border;\n    border-radius: @radius-lg;\n  }\n\n  .referral-card {\n    border-color: @border;\n    box-shadow: @shadow;\n  }\n\n  .referrals-cards-sort .th-sort {\n    border-color: @border;\n  }\n\n  .detail-card {\n    padding: 1rem;\n  }\n\n  .detail-meta {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .form-modal-overlay {\n    padding: 0;\n  }\n\n  .form-modal {\n    min-height: 100vh;\n    max-height: none;\n    border-radius: 0;\n  }\n}\n\n@media (max-width: 430px) {\n  .header-actions {\n    gap: 0.35rem;\n  }\n\n  .header-brand-divider,\n  .header-product {\n    display: none;\n  }\n\n  .header-brand {\n    display: none;\n  }\n\n  .header-client-logo {\n    position: static;\n    left: auto;\n    top: auto;\n    width: auto;\n    height: 40px;\n    margin-right: auto;\n    transform: none;\n    object-fit: contain;\n  }\n\n  .user-label {\n    padding-inline: 0.25rem;\n  }\n\n  .user-label-name {\n    max-width: 78px;\n  }\n\n  .btn-header {\n    padding-inline: 0.7rem;\n  }\n\n  .nav-tabs .nav-link.active[aria-current='page'] {\n    display: none;\n  }\n\n  .detail-meta {\n    grid-template-columns: 1fr;\n  }\n\n  .referral-card-head .status-with-overdue {\n    width: 100%;\n  }\n}\n\n@media (max-height: 720px) and (min-width: 681px) {\n  .login-panel {\n    padding-block: 1.25rem;\n  }\n\n  .login-header {\n    margin-bottom: 1.25rem;\n\n    h1 {\n      margin-top: 0.8rem;\n    }\n  }\n\n  .login-logo {\n    width: 30px;\n    height: 43px;\n  }\n\n  .login-form {\n    gap: 0.75rem;\n  }\n\n  .login-divider {\n    margin-block: 0.9rem;\n  }\n\n  .footer-need-help {\n    bottom: 0.85rem;\n  }\n}\n\n.mobile-test-page {\n  min-height: 100%;\n  background: @surface;\n\n  .sd-root-modern {\n    --sjs-primary-backcolor: @primary;\n    --sjs-primary-backcolor-dark: @primary-hover;\n    --sjs-general-backcolor: @surface;\n    --sjs-general-forecolor: @text;\n    --sjs-border-default: @border;\n    --sjs-font-family: var(--font);\n  }\n\n  .sd-body.sd-body--responsive {\n    padding: 0.5rem 0.35rem 1.5rem;\n  }\n}\n\n@import './faf.less';\n\n","/* FAF runtime step UI (google address + inline alert). */\n\n.faf-google-address {\n  width: 100%;\n}\n\n.faf-google-address-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.faf-google-address-input {\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: 2.75rem;\n  padding: 0.65rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--color-surface, #fff);\n  color: var(--color-text);\n  font: inherit;\n\n  &:focus {\n    border-color: var(--color-primary);\n    outline: 2px solid fade(#2b6cb0, 18%);\n    outline-offset: 1px;\n  }\n}\n\n.faf-google-address-map-btn {\n  flex: 0 0 auto;\n  min-width: 4.25rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-sm, 6px);\n  background: #f8fafc;\n  color: var(--color-text);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover {\n    border-color: var(--color-primary);\n    background: #edf6ff;\n  }\n}\n\n.faf-google-address.has-error .faf-google-address-input {\n  border-color: #dc2626;\n}\n\n.faf-inline-alert {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin: 0.35rem 0 0.65rem;\n  padding: 0.55rem 0.75rem;\n  border: 1px solid #f5c2c7;\n  border-radius: var(--radius-sm, 6px);\n  background: #fde8e8;\n  color: #842029;\n  font-size: 0.85rem;\n  line-height: 1.35;\n}\n\n.faf-inline-alert-text {\n  flex: 1 1 auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.faf-inline-alert-close {\n  flex: 0 0 auto;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 1.1rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 0.15rem;\n  opacity: 0.75;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.faf-google-map-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.45);\n}\n\n.faf-google-map-dialog {\n  width: min(720px, 100%);\n  max-height: calc(100vh - 2rem);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: var(--radius-md, 8px);\n  background: var(--color-surface, #fff);\n  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.28);\n}\n\n.faf-google-map-dialog-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.faf-google-map-hint {\n  font-size: 0.78rem;\n  color: var(--color-text-muted);\n}\n\n.faf-google-map-canvas {\n  width: 100%;\n  height: min(420px, 55vh);\n  background: #e2e8f0;\n}\n\n.faf-google-map-preview {\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--color-border);\n  border-bottom: 1px solid var(--color-border);\n  font-size: 0.9rem;\n  color: var(--color-text);\n  min-height: 2.75rem;\n}\n\n.faf-google-map-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
